import React, { useMemo, useState, useEffect, useRef } from "react";
import "./CollectedBills.css";
import "./InvoiceDigitization.css";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";

import { Button } from "../../../components/Button";
import { ReactComponent as ExcelIcon } from "../../../components/icons/excel.svg";
import moment from "moment";
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { useTable } from "react-table";
import { createPortal } from 'react-dom';
import FullscreenIcon from "@material-ui/icons/Fullscreen";
import FullscreenExitIcon from "@material-ui/icons/FullscreenExit";
import { CustomNextArrow, CustomPrevArrow } from "./CustomArrow";
import getCollectedBills from "../../../actions/creation/getCollectedBills";
import ImageViewer from "./imageCollectedBills";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@material-ui/icons/RadioButtonChecked"; // Filled icon for selected button
import DeleteIcon from "@material-ui/icons/Delete"; // Import the Delete icon
import getAssignSku from "../../../actions/creation/getAssignSku";
import CustomDropdown from "./CollectedBillsDropdown";
import Add from "@material-ui/icons/Add";
import CircularProgress from "@material-ui/core/CircularProgress";
import getGstAndPanDetails from "../../../actions/creation/getGstAndPanDetails";
import { bindActionCreators } from "redux";
// import { Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@material-ui/core";

import triggerNotification from "../../../actions/triggerNotification";
import { connect } from "react-redux";
import { getShortcutLabel, isSaveShortcut, isTotalImageShortcut, isViewImagesShortcut, isSaveInvoiceDetailsShortcut } from "./helper/shortcutUtils";
import ImageIcon from "@material-ui/icons/Image";
import EditIcon from "@material-ui/icons/Edit";
import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/Search";
import { Modal } from "../../../components/Modal";
import { SelectFilter } from "../components/SelectFilter";
import { components } from "react-select";

import { DASHBOARDROUTES } from "../../../helpers/constants/routes";
import {
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    TextField,
    Snackbar
} from "@material-ui/core"; // Import Material-UI components from core
import { triggerSimpleAjax } from "../../../helpers/httpHelper";
import { DELETE_COLLECTED_BILLS_SKU } from "../../../helpers/constants/apiUrl";
import getAddNewSkuData from "../../../actions/creation/getNewSkuData";
import createaddskuexcel from "../../../actions/creation/createAddNewSkuExcel";
import { black100, black200, black300, black500, blue300 } from "../../../theme/colors";
import { AppConfig } from "../../../app-config";
import { green } from "@material-ui/core/colors";
import { ArrowBack, ArrowForward, ChevronLeftRounded } from "@material-ui/icons";
import updateInvoiceNumber from "../../../actions/creation/updateInvoiceNumber";
import { GSTValidator, PANValidator, phoneNumberValidator } from "../../../utils/CommonFunction";
import { WORKFLOW_KEYS } from "../../../helpers/constants/workflowKeys";
import getOcrInvoice from "../../../actions/creation/getOcrInvoice";
import updateOcrInvoice from "../../../actions/creation/updateOcrInvoice";
import deleteOcrInvoiceSku from "../../../actions/creation/deleteOcrInvoiceSku";
import getSkuLite from "../../../actions/creation/getSkuLite";

let getcategoryDetailsStaticQueryParams =
    "&no-pagination&exclude_retailers=true";

const unwrapOcrResponse = (res) => {
    if (!res) return res;
    if (res.result !== undefined && res.result !== null) {
        return res.result;
    }
    return res;
};

const isFieldEdited = (item) => {
    if (!item) return false;
    return Boolean(
        item.is_mt_edited === true || item.is_mt_edited === "true" || item.is_mt_edited === 1 ||
        item.is_qc_edited === true || item.is_qc_edited === "true" || item.is_qc_edited === 1
    );
};

const isSkuNameHeaderField = (field) => {
    if (!field) return false;
    return field.tag === "sku_name" || (field.name && field.name.toLowerCase().trim() === "sku name");
};

const isPackshotImageField = (fieldOrCol) => {
    if (!fieldOrCol) return false;
    const header = String(
        fieldOrCol.Header ||
        fieldOrCol.headerName ||
        fieldOrCol.name ||
        fieldOrCol.sku_template_field_name ||
        ""
    ).toLowerCase().trim();
    const tag = String(fieldOrCol.tag || "").toLowerCase().trim();
    const type = String(
        fieldOrCol.type ||
        fieldOrCol.template_type ||
        fieldOrCol.sku_template_field_type ||
        ""
    ).toLowerCase().trim();

    return (
        header.includes("packshot") ||
        (header.includes("image") && !header.includes("invoice")) ||
        tag.includes("packshot") ||
        (tag.includes("image") && !tag.includes("invoice")) ||
        type === "image" ||
        type === "file"
    );
};

const normalizeCard = (rawCard) => {
    const card = unwrapOcrResponse(rawCard);
    if (!card) return card;

    let assignHeaderFields = card.assign_simplifiedinvoiceheader_field;
    let headerAnswers = card.simplifiedinvoiceheaderanswer;

    if (Array.isArray(card.invoice_headers) && card.invoice_headers.length > 0) {
        assignHeaderFields = card.invoice_headers.map((h) => ({
            id: h.id,
            name: h.name,
            type: h.header_type || h.type || "text",
            header_type: h.header_type || h.type || "text",
            tag: h.tag || "",
            is_mandatory: h.is_mandatory || false,
            validations: h.validations || {},
            show_logic_config: h.show_logic_config || null,
        }));

        headerAnswers = card.invoice_headers.map((h) => {
            const firstAns = Array.isArray(h.invoice_header_answer) ? h.invoice_header_answer[0] : null;
            return {
                id: firstAns?.id || null,
                invoice_header: h.id,
                single_input: firstAns?.single_input ?? "",
                invoice_header_type: h.header_type || h.type || "text",
                tag: h.tag || "",
                is_mt_edited: Boolean(firstAns?.is_mt_edited ?? h.is_mt_edited),
                is_qc_edited: Boolean(firstAns?.is_qc_edited ?? h.is_qc_edited),
                is_reviewed: Boolean(firstAns?.is_reviewed ?? h.is_reviewed),
                simplifiedinvoiceheaderanswerdetails: firstAns?.simplifiedinvoiceheaderanswerdetails || [],
            };
        });
    }

    let assignedSkuFields = card.assigned_sku_template_field || card.sku_template_headers;
    if (Array.isArray(assignedSkuFields) && assignedSkuFields.length > 0) {
        assignedSkuFields = assignedSkuFields.map((t) => ({
            id: t.id || t.sku_template_field,
            name: t.name || t.headerName || t.sku_template_field_name || `Field ${t.id}`,
            tag: t.tag || "",
            type: t.template_type || t.type || t.sku_template_field_type || "text",
            is_mandatory: t.is_mandatory || false,
            validations: t.validations || {},
        }));
    }

    const rawInvoiceSkus = card.invoice_sku || card.simplifiedinvoiceskudata || [];
    const rawAddonSkus = card.add_on_invoice_skus || card.simplifiedinvoiceaddonsku || [];

    if ((!Array.isArray(assignedSkuFields) || assignedSkuFields.length === 0) && (rawInvoiceSkus.length > 0 || rawAddonSkus.length > 0)) {
        const fieldMap = new Map();
        const collectFields = (skuList) => {
            skuList.forEach((item) => {
                const templates = item.sku_template || item.simplifiedinvoiceskudetails || [];
                templates.forEach((t) => {
                    const fieldId = t.id || t.sku_template_field;
                    if (fieldId && !fieldMap.has(fieldId)) {
                        fieldMap.set(fieldId, {
                            id: fieldId,
                            name: t.name || t.headerName || t.sku_template_field_name || `Field ${fieldId}`,
                            tag: t.tag || "",
                            type: t.template_type || t.type || t.sku_template_field_type || "text",
                            is_mandatory: t.is_mandatory || false,
                            validations: t.validations || {},
                        });
                    }
                });
            });
        };
        collectFields(rawInvoiceSkus);
        collectFields(rawAddonSkus);
        if (fieldMap.size > 0) {
            assignedSkuFields = Array.from(fieldMap.values());
        }
    }

    const normalizedSkuData = rawInvoiceSkus.map((skuItem) => {
        const skuName = skuItem.name || skuItem.sku_name || "";
        const skuId = skuItem.sku || skuItem.id;
        const templates = skuItem.sku_template || skuItem.simplifiedinvoiceskudetails || [];

        const details = templates.map((t) => {
            const fieldId = t.id || t.sku_template_field;

            // Match text answer by template id & sku id
            const textAnswers = Array.isArray(t.sku_template_answer)
                ? t.sku_template_answer
                : (t.sku_template_answer ? [t.sku_template_answer] : []);
            const matchingAns = textAnswers.find((ans) => {
                if (!ans) return false;
                const matchSku = ans.sku !== undefined && ans.sku !== null
                    ? String(ans.sku) === String(skuId) || String(ans.sku) === String(skuItem.sku) || String(ans.sku) === String(skuItem.id)
                    : true;
                const matchTemplate = ans.sku_template !== undefined && ans.sku_template !== null
                    ? String(ans.sku_template) === String(fieldId) || String(ans.sku_template) === String(t.id)
                    : true;
                return matchSku && matchTemplate;
            }) || textAnswers[0] || null;

            // Match image answer by template id & sku id
            const imageAnswers = Array.isArray(t.sku_template_image_answer)
                ? t.sku_template_image_answer
                : (t.sku_template_image_answer
                    ? [t.sku_template_image_answer]
                    : (Array.isArray(t.simplifiedinvoiceskuimageanswer) ? t.simplifiedinvoiceskuimageanswer : (t.image_answers || [])));

            const matchingImgAns = imageAnswers.find((ans) => {
                if (!ans) return false;
                const matchSku = ans.sku !== undefined && ans.sku !== null
                    ? String(ans.sku) === String(skuId) || String(ans.sku) === String(skuItem.sku) || String(ans.sku) === String(skuItem.id)
                    : true;
                const matchTemplate = ans.sku_template !== undefined && ans.sku_template !== null
                    ? String(ans.sku_template) === String(fieldId) || String(ans.sku_template) === String(t.id)
                    : true;
                return matchSku && matchTemplate;
            }) || imageAnswers[0] || null;

            const filesDetails = Array.isArray(matchingImgAns?.files_details)
                ? matchingImgAns.files_details
                : (matchingImgAns?.files_details ? [matchingImgAns.files_details] : []);
            const firstFileDetailUrl = filesDetails.find((f) => f && (f.file || f.url || f.image))?.file ||
                filesDetails.find((f) => f && (f.file || f.url || f.image))?.url ||
                filesDetails.find((f) => f && (f.file || f.url || f.image))?.image;

            const hasFilesDetails = Boolean(firstFileDetailUrl);
            const hasFilesList = Array.isArray(matchingImgAns?.files) && matchingImgAns.files.length > 0;
            const directImgUrl = matchingImgAns?.image || matchingImgAns?.file || matchingImgAns?.url || t.image;
            const hasDirectImage = Boolean(directImgUrl && typeof directImgUrl === "string");
            const hasImage = hasFilesDetails || hasFilesList || hasDirectImage;

            const cropImage = firstFileDetailUrl || directImgUrl || null;
            const isPackshot = isPackshotImageField(t) || t.template_type === "image" || t.type === "image";

            let val = "";
            if (isPackshot) {
                val = hasImage ? "Image Answered" : "";
            } else {
                val = matchingAns?.single_input ?? t.single_input ?? t.value ?? "";
            }

            return {
                id: matchingAns?.id || t.id || null,
                sku_template_field: fieldId,
                sku_template_field_name: t.name || t.headerName || t.sku_template_field_name,
                sku_template_field_type: t.template_type || t.type || t.sku_template_field_type,
                headerName: t.name || t.headerName || t.sku_template_field_name,
                type: t.template_type || t.type || t.sku_template_field_type,
                single_input: val,
                value: val,
                validations: t.validations,
                is_mandatory: t.is_mandatory,
                is_mt_edited: Boolean(matchingAns?.is_mt_edited ?? t.is_mt_edited),
                is_qc_edited: Boolean(matchingAns?.is_qc_edited ?? t.is_qc_edited),
                is_reviewed: Boolean(matchingAns?.is_reviewed ?? t.is_reviewed),
                image_answer: cropImage,
                has_image_answer: hasImage,
                files_details: filesDetails,
                simplifiedinvoiceskuimageanswer: matchingImgAns ? [matchingImgAns] : (Array.isArray(t.sku_template_image_answer) ? t.sku_template_image_answer : (t.simplifiedinvoiceskuimageanswer || [])),
            };
        });

        const skuNameTpl = templates.find((t) => isSkuNameHeaderField(t));
        const skuNameFirstAns = Array.isArray(skuNameTpl?.sku_template_answer) ? skuNameTpl.sku_template_answer[0] : null;
        const isSkuMtEdited = Boolean(skuNameFirstAns?.is_mt_edited ?? skuNameTpl?.is_mt_edited ?? skuItem?.is_mt_edited);
        const isSkuQcEdited = Boolean(skuNameFirstAns?.is_qc_edited ?? skuNameTpl?.is_qc_edited ?? skuItem?.is_qc_edited);

        return {
            ...skuItem,
            id: skuItem.id,
            sku_name: skuName,
            sku: skuId,
            is_mt_edited: isSkuMtEdited,
            is_qc_edited: isSkuQcEdited,
            simplifiedinvoiceskudetails: details,
        };
    });

    const normalizedAddonSkuData = rawAddonSkus.map((addonItem) => {
        const addonSkuName = addonItem.add_on_sku || addonItem.sku_name || "";
        const addonId = addonItem.id || addonItem.sku || addonItem.add_on_sku;
        const templates = addonItem.sku_template || addonItem.simplifiedinvoiceskudetails || [];

        const details = templates.map((t) => {
            const fieldId = t.id || t.sku_template_field;

            // Match text answer by template id & addon sku id
            const textAnswers = Array.isArray(t.sku_template_answer)
                ? t.sku_template_answer
                : (t.sku_template_answer ? [t.sku_template_answer] : []);
            const matchingAns = textAnswers.find((ans) => {
                if (!ans) return false;
                const matchSku = ans.addon_sku !== undefined && ans.addon_sku !== null
                    ? String(ans.addon_sku) === String(addonItem.id) || String(ans.addon_sku) === String(addonId)
                    : (ans.sku !== undefined && ans.sku !== null
                        ? String(ans.sku) === String(addonItem.sku) || String(ans.sku) === String(addonId)
                        : true);
                const matchTemplate = ans.sku_template !== undefined && ans.sku_template !== null
                    ? String(ans.sku_template) === String(fieldId) || String(ans.sku_template) === String(t.id)
                    : true;
                return matchSku && matchTemplate;
            }) || textAnswers[0] || null;

            // Match image answer by template id & addon sku id
            const imageAnswers = Array.isArray(t.sku_template_image_answer)
                ? t.sku_template_image_answer
                : (t.sku_template_image_answer
                    ? [t.sku_template_image_answer]
                    : (Array.isArray(t.simplifiedinvoiceskuimageanswer) ? t.simplifiedinvoiceskuimageanswer : (t.image_answers || [])));

            const matchingImgAns = imageAnswers.find((ans) => {
                if (!ans) return false;
                const matchSku = ans.addon_sku !== undefined && ans.addon_sku !== null
                    ? String(ans.addon_sku) === String(addonItem.id) || String(ans.addon_sku) === String(addonId)
                    : (ans.sku !== undefined && ans.sku !== null
                        ? String(ans.sku) === String(addonItem.sku) || String(ans.sku) === String(addonId)
                        : true);
                const matchTemplate = ans.sku_template !== undefined && ans.sku_template !== null
                    ? String(ans.sku_template) === String(fieldId) || String(ans.sku_template) === String(t.id)
                    : true;
                return matchSku && matchTemplate;
            }) || imageAnswers[0] || null;

            const filesDetails = Array.isArray(matchingImgAns?.files_details)
                ? matchingImgAns.files_details
                : (matchingImgAns?.files_details ? [matchingImgAns.files_details] : []);
            const firstFileDetailUrl = filesDetails.find((f) => f && (f.file || f.url || f.image))?.file ||
                filesDetails.find((f) => f && (f.file || f.url || f.image))?.url ||
                filesDetails.find((f) => f && (f.file || f.url || f.image))?.image;

            const hasFilesDetails = Boolean(firstFileDetailUrl);
            const hasFilesList = Array.isArray(matchingImgAns?.files) && matchingImgAns.files.length > 0;
            const directImgUrl = matchingImgAns?.image || matchingImgAns?.file || matchingImgAns?.url || t.image;
            const hasDirectImage = Boolean(directImgUrl && typeof directImgUrl === "string");
            const hasImage = hasFilesDetails || hasFilesList || hasDirectImage;

            const cropImage = firstFileDetailUrl || directImgUrl || null;
            const isPackshot = isPackshotImageField(t) || t.template_type === "image" || t.type === "image";

            let val = "";
            if (isPackshot) {
                val = hasImage ? "Image Answered" : "";
            } else {
                val = matchingAns?.single_input ?? t.single_input ?? t.value ?? "";
            }

            return {
                id: matchingAns?.id || t.id || null,
                sku_template_field: fieldId,
                sku_template_field_name: t.name || t.headerName || t.sku_template_field_name,
                sku_template_field_type: t.template_type || t.type || t.sku_template_field_type,
                headerName: t.name || t.headerName || t.sku_template_field_name,
                type: t.template_type || t.type || t.sku_template_field_type,
                single_input: val,
                value: val,
                validations: t.validations,
                is_mandatory: t.is_mandatory,
                is_mt_edited: Boolean(matchingAns?.is_mt_edited ?? t.is_mt_edited),
                is_qc_edited: Boolean(matchingAns?.is_qc_edited ?? t.is_qc_edited),
                is_reviewed: Boolean(matchingAns?.is_reviewed ?? t.is_reviewed),
                image_answer: cropImage,
                has_image_answer: hasImage,
                files_details: filesDetails,
                simplifiedinvoiceskuimageanswer: matchingImgAns ? [matchingImgAns] : (Array.isArray(t.sku_template_image_answer) ? t.sku_template_image_answer : (t.simplifiedinvoiceskuimageanswer || [])),
            };
        });

        const skuNameTpl = templates.find((t) => isSkuNameHeaderField(t));
        const skuNameFirstAns = Array.isArray(skuNameTpl?.sku_template_answer) ? skuNameTpl.sku_template_answer[0] : null;
        const isSkuMtEdited = Boolean(skuNameFirstAns?.is_mt_edited ?? skuNameTpl?.is_mt_edited ?? addonItem?.is_mt_edited);
        const isSkuQcEdited = Boolean(skuNameFirstAns?.is_qc_edited ?? skuNameTpl?.is_qc_edited ?? addonItem?.is_qc_edited);

        return {
            ...addonItem,
            id: addonItem.id,
            add_on_sku: addonSkuName,
            is_mt_edited: isSkuMtEdited,
            is_qc_edited: isSkuQcEdited,
            simplifiedinvoiceskudetails: details,
        };
    });

    return {
        ...card,
        assign_simplifiedinvoiceheader_field: assignHeaderFields || card.assign_simplifiedinvoiceheader_field,
        simplifiedinvoiceheaderanswer: headerAnswers || card.simplifiedinvoiceheaderanswer,
        assigned_sku_template_field: assignedSkuFields || card.assigned_sku_template_field,
        simplifiedinvoiceskudata: normalizedSkuData,
        simplifiedinvoiceaddonsku: normalizedAddonSkuData,
    };
};

const defaultAssignedHeaderFields = [];
const defaultAssignedSkuFields = [];
const defaultCardResult = {
    id: null,
    invoice_no: "",
    invoice_date: "",
    assign_simplifiedinvoiceheader_field: [],
    assigned_sku_template_field: [],
    simplifiedinvoiceheaderanswer: [],
    simplifiedinvoiceskudata: [],
    simplifiedinvoiceaddonsku: []
};


const InvoiceDigitization = (props) => {
    const [selectedCard, setSelectedCard] = useState(0);
    const cardContainerRef = useRef(null);

    const scroll = (scrollOffset) => {
        if (cardContainerRef.current) {
            cardContainerRef.current.scrollLeft += scrollOffset;
        }
    };

    const handleNextCard = () => {
        if (cardDataForSKus?.results && selectedCard < cardDataForSKus.results.length - 1) {
            const nextIndex = selectedCard + 1;
            setSelectedCard(nextIndex);
            setSelectedRowIndices([]);
            setErrorIndexes([]);
            setErrorMessages({});
            const nextCardId = cardDataForSKus.results[nextIndex]?.id;
            if (nextCardId) {
                fetchInvoiceDetail(nextIndex, nextCardId);
            }
            scroll(250);
        } else {
            scroll(250);
        }
    };

    const handlePrevCard = () => {
        if (selectedCard > 0) {
            const prevIndex = selectedCard - 1;
            setSelectedCard(prevIndex);
            setSelectedRowIndices([]);
            setErrorIndexes([]);
            setErrorMessages({});
            const prevCardId = cardDataForSKus?.results?.[prevIndex]?.id;
            if (prevCardId) {
                fetchInvoiceDetail(prevIndex, prevCardId);
            }
            scroll(-250);
        } else {
            scroll(-250);
        }
    };

    const normalizeHeaderType = (type = "", headerName = "", tag = "") => {
        const t = String(type || "").toLowerCase().trim().replace(/[\s_-]+/g, "");
        const tg = String(tag || "").toLowerCase().trim().replace(/[\s_-]+/g, "");
        if (t === "gstin" || t === "gstnumber" || t === "gst" || t === "gstno" || tg === "sellergstnumber" || tg === "buyergstnumber" || (tg && tg.includes("gst"))) return "gstin";
        if (t === "text" || t === "string") return "text";
        if (t === "date" || t === "datetime") return "date";
        if (t === "phonenumber" || t === "phone" || t === "mobile" || t === "mobilenumber" || t === "contact" || (tg && (tg.includes("mobile") || tg.includes("phone")))) return "phone_number";
        if (t === "pannumber" || t === "pan" || (tg && tg.includes("pan"))) return "pan_number";
        if (t === "integer" || t === "int" || t === "number") return "integer";
        if (t === "decimal" || t === "float" || t === "double" || t === "numeric") return "decimal";
        if (t === "dropdown" || t === "select") return "dropdown";
        if (t === "time") return "time";
        return t || "text";
    };

    const normalizeTemplateType = (type = "", headerName = "") => {
        const t = String(type || "").toLowerCase().trim().replace(/[\s_-]+/g, "");
        const h = String(headerName || "").toLowerCase().trim().replace(/[\s_-]+/g, "");
        if (t === "text" || t === "string") return "text";
        if (t === "date" || t === "datetime") return "date";
        if (t === "integer" || t === "int" || t === "number" || h.includes("qty") || h.includes("quantity")) return "integer";
        if (t === "decimal" || t === "float" || t === "double" || t === "numeric" || h.includes("mrp") || h.includes("rate") || h.includes("amount") || h.includes("price")) return "decimal";
        if (t === "dropdown" || t === "select") return "dropdown";
        if (t === "time") return "time";
        return t || "text";
    };

    const isInvoiceNoOrDate = (item) => {
        if (!item) return false;
        return item.tag === "invoice_number" || item.tag === "invoice_date";
    };

    const isInvoiceNoOrDateOrImage = isInvoiceNoOrDate;

    const isSkuNameOcrTemplateField = (field) => {
        if (!field) return false;
        const tag = String(field.tag || "").toLowerCase().trim();
        if (tag === "sku_name") return false;
        const name = String(field.name || field.headerName || field.Header || field.sku_template_field_name || "").toLowerCase().trim();
        return (
            tag === "sku_name_ocr" ||
            tag === "sku_ocr" ||
            tag === "ocr_sku_name" ||
            tag === "ocr" ||
            name === "sku name ocr" ||
            name === "sku_name_ocr" ||
            (name.includes("sku") && name.includes("ocr"))
        );
    };

    const isSkuNameTemplateField = (field) => {
        if (!field) return false;
        const tag = String(field.tag || "").toLowerCase().trim();
        if (tag === "sku_name") return true;
        if (isSkuNameOcrTemplateField(field)) return false;
        const name = String(field.name || field.headerName || field.Header || field.sku_template_field_name || "").toLowerCase().trim();
        return (
            tag === "sku" ||
            name === "sku name" ||
            name === "sku"
        );
    };

    const isSkuNameDbField = (fieldOrCol) => {
        if (!fieldOrCol) return false;
        if (isSkuNameOcrTemplateField(fieldOrCol)) return false;
        const header = String(
            fieldOrCol.Header ||
            fieldOrCol.headerName ||
            fieldOrCol.name ||
            fieldOrCol.sku_template_field_name ||
            ""
        ).toLowerCase().trim();
        const tag = String(fieldOrCol.tag || "").toLowerCase().trim();
        return (
            tag === "sku_name_db" ||
            tag === "sku_db" ||
            header === "sku name db" ||
            header === "sku_name_db" ||
            (header.includes("sku") && header.includes("db"))
        );
    };

    const isPackshotImageField = (fieldOrCol) => {
        if (!fieldOrCol) return false;
        const header = String(
            fieldOrCol.Header ||
            fieldOrCol.headerName ||
            fieldOrCol.name ||
            fieldOrCol.sku_template_field_name ||
            ""
        ).toLowerCase().trim();
        const tag = String(fieldOrCol.tag || "").toLowerCase().trim();
        const type = String(
            fieldOrCol.type ||
            fieldOrCol.template_type ||
            fieldOrCol.sku_template_field_type ||
            ""
        ).toLowerCase().trim();

        return (
            header.includes("packshot") ||
            (header.includes("image") && !header.includes("invoice")) ||
            tag.includes("packshot") ||
            (tag.includes("image") && !tag.includes("invoice")) ||
            type === "image" ||
            type === "file"
        );
    };

    const isAutoPopulatedDisabledSkuField = (fieldOrCol) => {
        return isSkuNameDbField(fieldOrCol);
    };

    const isDisabledSkuField = (fieldOrCol) => {
        // SKU Name DB and Packshot Image fields are disabled
        return isSkuNameDbField(fieldOrCol) || isPackshotImageField(fieldOrCol);
    };

    const isPhoneNumberValid = (phoneNumber) => {
        if (!phoneNumber || typeof phoneNumber !== "string") return false;
        let clean = phoneNumber.trim().replace(/[^0-9]/g, "");
        if (clean.length > 10 && clean.startsWith("91")) {
            clean = clean.slice(2);
        }
        const phoneRegex = /^[6-9]\d{9}$/;
        return phoneRegex.test(clean) && clean.length === 10;
    };

    const [isExpanded, setIsExpanded] = useState(true);
    const [loading, setLoading] = useState(true);
    const [loadingSku, setLoadingSku] = useState(true);
    const [cardDataForSKus, setCardDataForSKus] = useState();
    const [cardTexts, setCardTexts] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [skuName, setSkuName] = useState([]);
    const [savedCards, setSavedCards] = useState({});
    const [openDialog, setOpenDialog] = useState(false);
    const [open, setOpen] = useState(false);
    const [results, setResult] = useState([]);
    const [refreshData, setRefreshData] = useState(false);
    const [newAddedSKu, setNewAddedSKu] = useState([]);
    const [selectedSkuID, setSelectedSkuID] = useState(null);
    const [isNewSKUDelete, setIsNewSKUDelete] = useState(false);
    const [selectedRowIndex, setSelectedRowIndex] = useState(null);
    const [hasNewSku, setHasNewSku] = useState(false);
    const [editLoader, setEditLoader] = useState(false);
    const [localInvoiceHeaders, setLocalInvoiceHeaders] = useState([]);
    const [errorIndexes, setErrorIndexes] = useState([]);
    const [errorMessages, setErrorMessages] = useState({});
    const [invoiceNo, setInvoiceNo] = useState("");
    const [invoiceDate, setInvoiceDate] = useState("");
    const [error, setError] = useState(false);
    const [dateError, setDateError] = useState(false);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const [cropImageModalUrl, setCropImageModalUrl] = useState(null);
    const [openAddSkuModal, setOpenAddSkuModal] = useState(false);
    const [newSkuFormData, setNewSkuFormData] = useState({});
    const [addSkuModalErrors, setAddSkuModalErrors] = useState({});
    const [addSkuSearchInput, setAddSkuSearchInput] = useState("");

    const [isFirstModalActive, setFirstModalActive] = useState(false);
    const [testRowIndex, setTestRowIndex] = useState(-1);
    const [testCallIndex, setTestCallIndex] = useState(null);
    const [hasPendingRequests, setHasPendingRequests] = useState(false);
    const [skuLiteResults, setSkuLiteResults] = useState([]);
    const [skuSearchText, setSkuSearchText] = useState("");
    const [modalSearchText, setModalSearchText] = useState("");
    const [skuPage, setSkuPage] = useState(1);
    const [skuTotalPages, setSkuTotalPages] = useState(1);
    const [skuTotalCount, setSkuTotalCount] = useState(0);
    const [selectedRowIndices, setSelectedRowIndices] = useState([]);
    const [isBulkDelete, setIsBulkDelete] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [toastOpen, setToastOpen] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [toastSeverity, setToastSeverity] = useState("error");
    const [modalErrorMessage, setModalErrorMessage] = useState("");

    const showToast = (message, severity = "error") => {
        setToastMessage(message);
        setToastSeverity(severity);
        setToastOpen(true);
    };

    useEffect(() => {
        const handleWheel = (e) => {
            if (
                document.activeElement &&
                (document.activeElement.type === "number" ||
                    document.activeElement.getAttribute("inputmode") === "decimal" ||
                    document.activeElement.classList.contains("sku-row-input"))
            ) {
                document.activeElement.blur();
            }
        };
        window.addEventListener("wheel", handleWheel, { passive: true });
        return () => {
            window.removeEventListener("wheel", handleWheel);
        };
    }, []);

    useEffect(() => {
        if (!isFirstModalActive) return;
        const timer = setTimeout(() => {
            setSkuSearchText(modalSearchText);
            setSkuPage(1);
        }, 400);

        return () => clearTimeout(timer);
    }, [modalSearchText, isFirstModalActive]);

    useEffect(() => {
        if (!openAddSkuModal) return;
        const timer = setTimeout(() => {
            setSkuSearchText(addSkuSearchInput);
            setSkuPage(1);
        }, 350);

        return () => clearTimeout(timer);
    }, [addSkuSearchInput, openAddSkuModal]);

    useEffect(() => {
        setSelectedRowIndices([]);
    }, [selectedCard]);

    useEffect(() => {
        setLoadingSku(true);
        const fetchPageSize = openAddSkuModal ? 50 : 1000;
        getSkuLite(skuSearchText || "", skuPage, fetchPageSize)
            .then((res) => {
                const dataObj = unwrapOcrResponse(res);
                const rawList = Array.isArray(dataObj?.results)
                    ? dataObj.results
                    : Array.isArray(res?.results)
                        ? res.results
                        : Array.isArray(dataObj)
                            ? dataObj
                            : [];
                const totalPages = dataObj?.total_number_of_pages || res?.total_number_of_pages || 1;
                const count = dataObj?.count || res?.count || rawList.length;

                setSkuTotalPages(totalPages);
                setSkuTotalCount(count);

                const mapped = rawList.map((item) => ({
                    sku_name: item.name || item.sku_name || "",
                    sku: item.id || item.sku,
                    sku_id: item.id || item.sku
                }));

                if (openAddSkuModal && skuPage > 1) {
                    setSkuLiteResults((prev) => {
                        const existingKeys = new Set(prev.map((p) => String(p.sku || p.sku_name)));
                        const newItems = mapped.filter((m) => !existingKeys.has(String(m.sku || m.sku_name)));
                        return [...prev, ...newItems];
                    });
                } else {
                    setSkuLiteResults(mapped);
                }
            })
            .catch(() => { })
            .finally(() => {
                setLoadingSku(false);
            });
    }, [skuSearchText, skuPage, openAddSkuModal]);

    const combinedSkuOptions = useMemo(() => {
        if (skuLiteResults && skuLiteResults.length > 0) {
            return skuLiteResults;
        }
        return results || [];
    }, [results, skuLiteResults]);

    const skuSelectOptions = useMemo(() => {
        return (combinedSkuOptions || []).map((item) => ({
            label: `${item.sku_name} ${item.sku ? `(#${item.sku})` : ""}`,
            value: item.sku ? String(item.sku) : item.sku_name,
            sku_name: item.sku_name,
            sku: item.sku,
        }));
    }, [combinedSkuOptions]);

    const filteredModalSkuOptions = useMemo(() => {
        if (!modalSearchText) return combinedSkuOptions;
        const lower = modalSearchText.toLowerCase();
        return combinedSkuOptions.filter((item) =>
            (item.sku_name || "").toLowerCase().includes(lower) ||
            String(item.sku || "").includes(lower)
        );
    }, [combinedSkuOptions, modalSearchText]);

    const SkuSelectMenu = useMemo(() => {
        return (menuProps) => {
            return (
                <components.Menu {...menuProps}>
                    {menuProps.children}
                    {loadingSku && skuPage > 1 && (
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "8px",
                                padding: "8px 12px",
                                background: "#f8fafc",
                                borderTop: "1px solid #e2e8f0",
                                borderBottomLeftRadius: "8px",
                                borderBottomRightRadius: "8px",
                                color: "#2563eb",
                                fontSize: "12px",
                                fontWeight: 600,
                                fontFamily: "Barlow, sans-serif",
                            }}
                        >
                            <CircularProgress size={14} style={{ color: "#2563eb" }} />
                            <span>Loading more SKUs...</span>
                        </div>
                    )}
                    {!loadingSku && skuPage >= skuTotalPages && combinedSkuOptions.length > 0 && (
                        <div
                            style={{
                                padding: "6px 12px",
                                textAlign: "center",
                                fontSize: "11px",
                                color: "#94a3b8",
                                background: "#f8fafc",
                                borderTop: "1px solid #f1f5f9",
                                fontFamily: "Barlow, sans-serif",
                            }}
                        >
                            All {skuTotalCount ? skuTotalCount.toLocaleString() : combinedSkuOptions.length} SKUs loaded
                        </div>
                    )}
                </components.Menu>
            );
        };
    }, [loadingSku, skuPage, skuTotalPages, skuTotalCount, combinedSkuOptions.length]);

    const selectComponents = useMemo(() => ({ Menu: SkuSelectMenu }), [SkuSelectMenu]);




    const today = new Date().toISOString().split("T")[0];

    const currentPermission = props?.workflow_permission || props?.outletDetails?.workflow_permission;
    const isQCExecutive = currentPermission === WORKFLOW_KEYS.QC_EXECUTIVE;
    const enableEditAnswers = Boolean(isQCExecutive && props?.enableEditAnswers !== false);

    useEffect(() => {

        fetchData();
    }, [refreshData]);


    async function fetchInvoiceDetail(cardIndex, explicitId = null) {
        if (cardIndex === "new-sku") return;
        const currentCard = cardDataForSKus?.results?.[cardIndex];
        const invoiceId = explicitId || currentCard?.id;
        if (!invoiceId) return;

        try {
            setLoading(true);
            const rawSingle = await getOcrInvoice(invoiceId, false);
            const singleRes = unwrapOcrResponse(rawSingle);
            const normalizedCard = normalizeCard(singleRes);

            setCardDataForSKus((prevData) => {
                if (!prevData?.results) return prevData;
                const updatedResults = [...prevData.results];
                updatedResults[cardIndex] = normalizedCard;
                return {
                    ...prevData,
                    results: updatedResults,
                };
            });
        } catch (err) {
            console.error("Error fetching OCR invoice detail:", err);
        } finally {
            setLoading(false);
        }
    }

    async function fetchData() {
        try {
            setLoading(true);
            setTableData([]);
            let response;

            if (props.ocrInvoiceId || props.invoiceId) {
                const ocrId = props.ocrInvoiceId || props.invoiceId;
                const rawSingle = await getOcrInvoice(ocrId, false);
                const singleRes = unwrapOcrResponse(rawSingle);
                response = { results: [normalizeCard(singleRes)] };
            } else {
                const req = props.outletDetails?.workflow_object;
                let rawResponse;
                try {
                    rawResponse = await getOcrInvoice(req, true);
                } catch (e) {
                    rawResponse = await getCollectedBills(req);
                }

                const dataObj = unwrapOcrResponse(rawResponse);
                const list = Array.isArray(dataObj?.results)
                    ? dataObj.results
                    : Array.isArray(rawResponse?.results)
                        ? rawResponse.results
                        : Array.isArray(dataObj)
                            ? dataObj
                            : [];

                if (list.length > 0) {
                    response = {
                        ...(dataObj && typeof dataObj === 'object' ? dataObj : {}),
                        results: list.map(normalizeCard)
                    };
                } else if (dataObj && typeof dataObj === 'object' && !dataObj.results) {
                    response = { results: [normalizeCard(dataObj)] };
                } else {
                    response = rawResponse;
                }
            }

            if (!response?.results || response.results.length === 0) {
                setCardDataForSKus({ results: [] });
                setCardTexts([]);
            } else {
                setCardDataForSKus(response);
                setCardTexts(
                    response?.results.map(
                        (card) => `${card.invoice_date || today}, ${card.invoice_no || "Draft"}`
                    ) || []
                );

                const targetIndex = (typeof selectedCard === "number" && selectedCard >= 0 && selectedCard < response.results.length) ? selectedCard : 0;
                const targetCardId = response.results[targetIndex]?.id;
                if (targetCardId) {
                    try {
                        const rawTargetCard = await getOcrInvoice(targetCardId, false);
                        const detailedTargetCard = unwrapOcrResponse(rawTargetCard);
                        if (detailedTargetCard && typeof detailedTargetCard === "object" && Object.keys(detailedTargetCard).length > 0) {
                            response.results[targetIndex] = normalizeCard(detailedTargetCard);
                            setCardDataForSKus({ ...response });
                        }
                    } catch (e) { }
                }
            }
            setLoading(false);
        } catch (error) {
            setCardDataForSKus({ results: [] });
            setCardTexts([]);
            setLoading(false);
        }
    }

    useEffect(() => {
        if (
            typeof selectedCard === "number" &&
            selectedCard >= 0 &&
            cardDataForSKus?.results?.[selectedCard]
        ) {
            const currentCard = cardDataForSKus.results[selectedCard];
            const hasDetails = Boolean(
                (currentCard.invoice_headers && currentCard.invoice_headers.length > 0) ||
                (currentCard.invoice_sku && currentCard.invoice_sku.length > 0) ||
                (currentCard.simplifiedinvoiceskudata && currentCard.simplifiedinvoiceskudata.length > 0)
            );

            if (!hasDetails && currentCard.id) {
                fetchInvoiceDetail(selectedCard, currentCard.id);
            }
        }
    }, [selectedCard, cardDataForSKus]);




    const handleChange = (e) => {
        const val = e.target.value;
        setInvoiceNo(val);
        const currentCard = cardDataForSKus?.results?.[selectedCard];
        const invNoHdr = (
            (currentCard?.invoice_headers || []).find((h) => h.tag === "invoice_number" || (h.name && h.name.toLowerCase().trim() === "invoice number")) ||
            (currentCard?.assign_simplifiedinvoiceheader_field || []).find((h) => h.tag === "invoice_number" || (h.name && h.name.toLowerCase().trim() === "invoice number")) ||
            (localInvoiceHeaders || []).find((h) => h.tag === "invoice_number" || (h.header && h.header.toLowerCase().trim() === "invoice number"))
        );
        const isInvNoMandatory = invNoHdr?.is_mandatory !== undefined ? Boolean(invNoHdr.is_mandatory) : true;
        if (isInvNoMandatory) {
            setError(val.trim() === "");
        } else {
            setError(false);
        }
    };

    const handleBlur = () => {
        const currentCard = cardDataForSKus?.results?.[selectedCard];
        const invNoHdr = (
            (currentCard?.invoice_headers || []).find((h) => h.tag === "invoice_number" || (h.name && h.name.toLowerCase().trim() === "invoice number")) ||
            (currentCard?.assign_simplifiedinvoiceheader_field || []).find((h) => h.tag === "invoice_number" || (h.name && h.name.toLowerCase().trim() === "invoice number")) ||
            (localInvoiceHeaders || []).find((h) => h.tag === "invoice_number" || (h.header && h.header.toLowerCase().trim() === "invoice number"))
        );
        const isInvNoMandatory = invNoHdr?.is_mandatory !== undefined ? Boolean(invNoHdr.is_mandatory) : true;
        if (isInvNoMandatory) {
            setError(!invoiceNo || String(invoiceNo).trim() === "");
        }
    };

    const handleDateChange = (e) => {
        const val = e.target.value;
        setInvoiceDate(val);
        const currentCard = cardDataForSKus?.results?.[selectedCard];
        const invDateHdr = (
            (currentCard?.invoice_headers || []).find((h) => h.tag === "invoice_date" || (h.name && h.name.toLowerCase().trim() === "invoice date")) ||
            (currentCard?.assign_simplifiedinvoiceheader_field || []).find((h) => h.tag === "invoice_date" || (h.name && h.name.toLowerCase().trim() === "invoice date")) ||
            (localInvoiceHeaders || []).find((h) => h.tag === "invoice_date" || (h.header && h.header.toLowerCase().trim() === "invoice date"))
        );
        const isInvDateMandatory = Boolean(invDateHdr?.is_mandatory);
        if (isInvDateMandatory) {
            setDateError(!val || String(val).trim() === "");
        } else {
            setDateError(false);
        }
    };

    const handleDateBlur = () => {
        const currentCard = cardDataForSKus?.results?.[selectedCard];
        const invDateHdr = (
            (currentCard?.invoice_headers || []).find((h) => h.tag === "invoice_date" || (h.name && h.name.toLowerCase().trim() === "invoice date")) ||
            (currentCard?.assign_simplifiedinvoiceheader_field || []).find((h) => h.tag === "invoice_date" || (h.name && h.name.toLowerCase().trim() === "invoice date")) ||
            (localInvoiceHeaders || []).find((h) => h.tag === "invoice_date" || (h.header && h.header.toLowerCase().trim() === "invoice date"))
        );
        const isInvDateMandatory = Boolean(invDateHdr?.is_mandatory);
        if (isInvDateMandatory) {
            setDateError(!invoiceDate || String(invoiceDate).trim() === "");
        }
    };

    const handleEditClick = (index) => {
        setError(false);
        setDateError(false);
        setOpen(true);
    };

    const handleSave = async () => {
        const { notificationHandler } = props;

        const currentCardData = cardDataForSKus?.results[selectedCard];
        const invNoHdr = (
            (currentCardData?.invoice_headers || []).find((h) => h.tag === "invoice_number" || (h.name && h.name.toLowerCase().trim() === "invoice number")) ||
            (currentCardData?.assign_simplifiedinvoiceheader_field || []).find((h) => h.tag === "invoice_number" || (h.name && h.name.toLowerCase().trim() === "invoice number")) ||
            (localInvoiceHeaders || []).find((h) => h.tag === "invoice_number" || (h.header && h.header.toLowerCase().trim() === "invoice number"))
        );
        const isInvNoMandatory = invNoHdr?.is_mandatory !== undefined ? Boolean(invNoHdr.is_mandatory) : true;

        const invDateHdr = (
            (currentCardData?.invoice_headers || []).find((h) => h.tag === "invoice_date" || (h.name && h.name.toLowerCase().trim() === "invoice date")) ||
            (currentCardData?.assign_simplifiedinvoiceheader_field || []).find((h) => h.tag === "invoice_date" || (h.name && h.name.toLowerCase().trim() === "invoice date")) ||
            (localInvoiceHeaders || []).find((h) => h.tag === "invoice_date" || (h.header && h.header.toLowerCase().trim() === "invoice date"))
        );
        const isInvDateMandatory = Boolean(invDateHdr?.is_mandatory);

        let hasValidationError = false;
        if (isInvNoMandatory && (!invoiceNo || String(invoiceNo).trim() === "")) {
            setError(true);
            hasValidationError = true;
        }
        if (isInvDateMandatory && (!invoiceDate || String(invoiceDate).trim() === "")) {
            setDateError(true);
            hasValidationError = true;
        }

        if (hasValidationError) {
            return;
        }

        const payload = {};
        if (invoiceNo) {
            payload.invoice_no = invoiceNo;
        }
        if (invoiceDate) {
            payload.invoice_date = invoiceDate;
        }

        try {
            const response = await updateOcrInvoice(
                currentCardData.id, payload
            );
            notificationHandler({
                messageText: `Invoice number and date saved successfully.`,
                status: "SUCCESS",
            });
            setRefreshData((prev) => !prev);
        } catch (error) {
            setInvoiceNo(cardDataForSKus?.results[selectedCard]?.invoice_no);

            notificationHandler({
                messageText: error.message,
                status: "FAILED",
            });
        } finally {
            setEditLoader(false);
        }

        setOpen(false);
    };

    const handleClose = () => {
        setError(false);
        setDateError(false);
        setOpen(false);
    };

    useEffect(() => {
        if (selectedCard === "new-sku") {
            const req = props.outletDetails.workflow_object;
            async function fetchNewSKuData() {
                try {
                    // const req = props.outletDetails.workflow_object;
                    setLoading(true);
                    const response = await getAddNewSkuData(req);
                    setNewAddedSKu(response);
                    setLoading(false);
                } catch (error) {
                    setLoading(false);
                }
            }
            fetchNewSKuData();
        }
    }, [selectedCard]);

    useEffect(() => {
        const subProjectSlugId = props.outletDetails.sub_project.slug;
        const req = `?sub_project__slug=${subProjectSlugId}${getcategoryDetailsStaticQueryParams}`;
        setLoadingSku(true);
        getAssignSku(req).then((response) => {
            const { results } = response;
            const skuNames = results.map((name) => name.sku_name);
            const skuData = results.map((item) => ({
                sku_name: item.sku_name,
                sku: item.sku,
            }));
            setLoadingSku(false);
            setResult(skuData);
            setSkuName(skuNames);
        });
    }, [props.outletDetails.sub_project.slug]);

    const handleCardClick = (index) => {
        setSelectedCard(index);
        setSelectedRowIndices([]);
        setErrorIndexes([]);
        setErrorMessages({});
        const cardId = cardDataForSKus?.results?.[index]?.id;
        if (cardId) {
            fetchInvoiceDetail(index, cardId);
        }
    };

    const toggleExpandCollapse = () => {
        setIsExpanded(!isExpanded);
    };

    const handleOpenDialog = (skuID, rowIndex, isNewSKUDelete) => {
        setIsBulkDelete(false);
        setIsNewSKUDelete(isNewSKUDelete);
        setSelectedSkuID(skuID);
        setSelectedRowIndex(rowIndex);
        setOpenDialog(true);
    };

    const handleOpenBulkDeleteDialog = () => {
        if (selectedRowIndices.length === 0) return;
        setIsBulkDelete(true);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        if (isDeleting) return;
        setOpenDialog(false);
        setIsBulkDelete(false);
    };

    const confirmDelete = async () => {
        if (isDeleting) return;
        setIsDeleting(true);
        try {
            if (isBulkDelete) {
                await handleDeleteSelectedRows();
            } else {
                await handleDeleteRow();
            }
            setOpenDialog(false);
            setIsBulkDelete(false);
        } catch (err) {
            console.error("Error confirming delete:", err);
        } finally {
            setIsDeleting(false);
        }
    };

    const checkForNewSkus = () => {
        const newSkuExists = tableData.some((row) => {
            const hasAddon = Boolean(row.add_on_sku && String(row.add_on_sku).trim() !== "");
            const hasSelectedSku = Boolean(
                row.sku || (row.sku_name && String(row.sku_name).trim() !== "" && row.sku_name !== "Select SKU")
            );
            return hasAddon && !hasSelectedSku;
        });

        setHasNewSku(newSkuExists);
    };

    // Call this function whenever tableData changes
    useEffect(() => {
        checkForNewSkus();



    }, [tableData]);

    const [validationErrors, setValidationErrors] = useState([]);

    useEffect(() => {
        setValidationErrors([]);
    }, [selectedCard]);

    const validateTableData = () => {
        const errors = [];

        tableData.forEach((row, rowIndex) => {
            const sku_name = row.sku_name || row.add_on_sku;

            if (!sku_name || String(sku_name).trim() === "") {
                errors.push({
                    rowIndex,
                    columnId: "sku_name",
                    message: `SKU Name cannot be empty.`,
                });
            }

            columns.forEach((column) => {
                if (!column || column.accessor === "sku_name" || column.accessor === "add_on_sku") {
                    return;
                }

                const columnId = column.accessor;
                const cellValObj = row[columnId] ?? row[column.Header];

                let headerName = column.Header || columnId;
                let rawType = column.type || "text";
                let validations = column.validations || {};
                let isMandatory = column.is_mandatory || false;

                let cellRawVal = "";
                if (typeof cellValObj === "object" && cellValObj !== null) {
                    cellRawVal = cellValObj.value !== undefined && cellValObj.value !== null ? cellValObj.value : "";
                    if (cellValObj.headerName) headerName = cellValObj.headerName;
                    if (cellValObj.type) rawType = cellValObj.type;
                    if (cellValObj.validations) validations = cellValObj.validations;
                    if (cellValObj.is_mandatory !== undefined) isMandatory = cellValObj.is_mandatory;
                } else if (cellValObj !== undefined && cellValObj !== null) {
                    cellRawVal = cellValObj;
                }

                let trimmedValue = String(cellRawVal).trim();
                const normType = normalizeTemplateType(rawType, headerName);

                if (normType === "decimal") {
                    if (trimmedValue.startsWith(".")) {
                        trimmedValue = "0" + trimmedValue;
                        if (typeof cellValObj === "object" && cellValObj !== null) {
                            cellValObj.value = trimmedValue;
                        } else {
                            row[columnId] = trimmedValue;
                        }
                    }
                }

                if (trimmedValue === "") {
                    if (isMandatory && !isDisabledSkuField(column) && !isDisabledSkuField(cellValObj)) {
                        errors.push({
                            rowIndex,
                            columnId,
                            message: `${headerName} cannot be empty.`,
                        });
                    }
                    return;
                }

                switch (normType) {
                    case "text":
                        if (validations.min_length && trimmedValue.length < parseInt(validations.min_length, 10)) {
                            errors.push({
                                rowIndex,
                                columnId,
                                message: `${headerName} must be at least ${validations.min_length} characters.`,
                            });
                        }
                        if (validations.max_length && trimmedValue.length > parseInt(validations.max_length, 10)) {
                            errors.push({
                                rowIndex,
                                columnId,
                                message: `${headerName} must not exceed ${validations.max_length} characters.`,
                            });
                        }
                        break;

                    case "integer":
                        if (trimmedValue.startsWith("-")) {
                            errors.push({
                                rowIndex,
                                columnId,
                                message: `${headerName} cannot be negative.`,
                            });
                        } else if (trimmedValue.includes(".") || !/^\d+$/.test(trimmedValue)) {
                            errors.push({
                                rowIndex,
                                columnId,
                                message: `${headerName} must be a number.`,
                            });
                        } else {
                            const numericValue = parseInt(trimmedValue, 10);
                            if (isNaN(numericValue) || numericValue < 0) {
                                errors.push({
                                    rowIndex,
                                    columnId,
                                    message: `${headerName} cannot be negative.`,
                                });
                            } else {
                                if (validations.lower_limit && numericValue < parseFloat(validations.lower_limit)) {
                                    errors.push({
                                        rowIndex,
                                        columnId,
                                        message: `${headerName} must be greater than or equal to ${validations.lower_limit}.`,
                                    });
                                }
                                if (validations.upper_limit && numericValue > parseFloat(validations.upper_limit)) {
                                    errors.push({
                                        rowIndex,
                                        columnId,
                                        message: `${headerName} must be less than or equal to ${validations.upper_limit}.`,
                                    });
                                }
                            }
                        }
                        break;

                    case "decimal":
                        if (trimmedValue.startsWith("-")) {
                            errors.push({
                                rowIndex,
                                columnId,
                                message: `${headerName} cannot be negative.`,
                            });
                        } else if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(trimmedValue)) {
                            errors.push({
                                rowIndex,
                                columnId,
                                message: `${headerName} must be a valid number.`,
                            });
                        } else {
                            const numericValue = parseFloat(trimmedValue);
                            if (isNaN(numericValue) || numericValue < 0) {
                                errors.push({
                                    rowIndex,
                                    columnId,
                                    message: `${headerName} cannot be negative.`,
                                });
                            } else {
                                if (validations.lower_limit && numericValue < parseFloat(validations.lower_limit)) {
                                    errors.push({
                                        rowIndex,
                                        columnId,
                                        message: `${headerName} must be greater than or equal to ${validations.lower_limit}.`,
                                    });
                                }
                                if (validations.upper_limit && numericValue > parseFloat(validations.upper_limit)) {
                                    errors.push({
                                        rowIndex,
                                        columnId,
                                        message: `${headerName} must be less than or equal to ${validations.upper_limit}.`,
                                    });
                                }
                            }
                        }
                        break;

                    case "dropdown":
                        if (validations.choices && !validations.choices.split(";").map((c) => c.trim()).includes(trimmedValue)) {
                            errors.push({
                                rowIndex,
                                columnId,
                                message: `${headerName} must be one of the allowed choices: ${validations.choices}.`,
                            });
                        }
                        break;

                    case "date":
                        const dateValue = Date.parse(trimmedValue);
                        if (isNaN(dateValue)) {
                            errors.push({
                                rowIndex,
                                columnId,
                                message: `${headerName} must be a valid date.`,
                            });
                        } else {
                            const parsedDate = new Date(dateValue);
                            if (validations.lower_than && parsedDate >= new Date(validations.lower_than)) {
                                errors.push({
                                    rowIndex,
                                    columnId,
                                    message: `${headerName} must be earlier than ${validations.lower_than}.`,
                                });
                            }
                            if (validations.greater_than && parsedDate <= new Date(validations.greater_than)) {
                                errors.push({
                                    rowIndex,
                                    columnId,
                                    message: `${headerName} must be later than ${validations.greater_than}.`,
                                });
                            }
                        }
                        break;

                    case "time":
                        const timeValue = Date.parse(`1970-01-01T${trimmedValue}Z`);
                        if (isNaN(timeValue)) {
                            errors.push({
                                rowIndex,
                                columnId,
                                message: `${headerName} must be a valid time.`,
                            });
                        } else {
                            const parsedTime = new Date(timeValue);
                            if (validations.lower_than && parsedTime >= new Date(`1970-01-01T${validations.lower_than}Z`)) {
                                errors.push({
                                    rowIndex,
                                    columnId,
                                    message: `${headerName} must be earlier than ${validations.lower_than}.`,
                                });
                            }
                            if (validations.greater_than && parsedTime <= new Date(`1970-01-01T${validations.greater_than}Z`)) {
                                errors.push({
                                    rowIndex,
                                    columnId,
                                    message: `${headerName} must be later than ${validations.greater_than}.`,
                                });
                            }
                        }
                        break;

                    default:
                        break;
                }
            });
        });

        setValidationErrors(errors);

        return errors.length === 0;
    };

    const handleSaveNext = async () => {
        const isValid = validateTableData();


        if (!isValid) {
            return;
        }
        setEditLoader(true);

        const currentCardData = cardDataForSKus?.results[selectedCard];

        if (!currentCardData) {
            props.setIsSliderComplete && props.setIsSliderComplete(true);
            if (props.onComplete) {
                props.onComplete();
            } else if (props.onSaveNext) {
                props.onSaveNext();
            }
            setEditLoader(false);
            return;
        }


        // Perform validation: Check if any required field is empty
        const hasEmptyFields = tableData.some((row, rowIndex) => {
            const emptyFields = Object.entries(row).filter(([key, value]) => {
                return value === "" || value === null || value === undefined;
            });

            return false;
        });

        if (hasEmptyFields) {
            // Stop further processing if validation fails
            setEditLoader(false); // Hide loader
            return;
        }

        setEditLoader(true);
        const tableDataMap = tableData.reduce((map, row) => {
            map[row.id] = row; // Assuming `id` is unique, else use `sku_name`
            return map;
        }, {});

        let isOuterEdit = false;
        let isOuterSkuDataEdit = false;

        const getFieldName = (key) => {
            const fieldDetail = currentCardData.assigned_sku_template_field.find(
                (field) => field.id === parseInt(key)
            );

            return fieldDetail ? fieldDetail.name : key; // Fallback to key if name is not found
        };

        const getFieldType = (key) => {
            const fieldDetail = currentCardData.assigned_sku_template_field.find(
                (field) => field.id === parseInt(key)
            );
            return fieldDetail ? fieldDetail.type : key; // Fallback to key if type is not found
        };

        const updatedSkuData = currentCardData.simplifiedinvoiceskudata?.map(
            (skuItem) => {
                const matchingRow = tableDataMap[skuItem.id]; // Match by `id` instead of `sku_name`
                let isSkuDataEdited = false;
                const updatedSkuDetails = skuItem.simplifiedinvoiceskudetails.map(
                    (skuDetail, index) => {
                        const tableValue = matchingRow
                            ? matchingRow[skuDetail.sku_template_field]
                            : undefined;

                        let finalValue = skuDetail.single_input;
                        let singleInputObj = null;

                        if (typeof tableValue === "object" && tableValue !== null) {
                            singleInputObj = tableValue;
                            finalValue = tableValue.value !== undefined ? tableValue.value : "";
                        } else if (
                            typeof skuDetail.single_input === "object" &&
                            skuDetail.single_input !== null
                        ) {
                            singleInputObj = skuDetail.single_input;
                            finalValue =
                                skuDetail.single_input.value !== undefined
                                    ? skuDetail.single_input.value
                                    : "";
                        } else if (tableValue !== undefined) {
                            finalValue = tableValue;
                        }

                        if (
                            tableValue !== undefined &&
                            tableValue !== skuDetail.single_input
                        ) {
                            isSkuDataEdited = true;
                            isOuterEdit = true;
                        }

                        const fieldInfo = currentCardData.assigned_sku_template_field?.find(
                            (f) => f.id === parseInt(skuDetail.sku_template_field)
                        );

                        const headerName = singleInputObj?.headerName || fieldInfo?.name;
                        const type =
                            singleInputObj?.type ||
                            fieldInfo?.type ||
                            skuDetail.sku_template_field_type;
                        const validations =
                            singleInputObj?.validations || fieldInfo?.validations;
                        const is_mandatory =
                            singleInputObj?.is_mandatory ?? fieldInfo?.is_mandatory;

                        return {
                            ...skuDetail,
                            is_edit: isSkuDataEdited,
                            ...(headerName !== undefined && { headerName }),
                            value: finalValue,
                            ...(type !== undefined && { type }),
                            ...(validations !== undefined && { validations }),
                            ...(is_mandatory !== undefined && { is_mandatory }),
                            single_input: finalValue,
                        };
                    }
                );

                // Handle additional fields from currentCardData.assigned_sku_template_field
                currentCardData.assigned_sku_template_field.forEach((field) => {
                    const fieldExists = skuItem.simplifiedinvoiceskudetails.some(
                        (detail) => detail.sku_template_field === field.id
                    );

                    if (!fieldExists) {
                        const rawTableVal = matchingRow ? matchingRow[field.id] : "";
                        const valObj =
                            typeof rawTableVal === "object" && rawTableVal !== null
                                ? rawTableVal
                                : {};
                        const tableValue =
                            valObj.value !== undefined ? valObj.value : rawTableVal;

                        updatedSkuDetails.push({
                            id: null,
                            sku_template_field: field.id,
                            sku_template_field_type: field.type,
                            sku_template_field_name: field.name,
                            headerName: field.name,
                            value: tableValue || "",
                            type: field.type,
                            validations: field.validations,
                            is_mandatory: field.is_mandatory,
                            single_input: tableValue || "",
                            simplifiedinvoiceskuimageanswer: [],
                            is_edit: true,
                        });

                        isSkuDataEdited = true;
                        isOuterEdit = true;
                    }
                });

                if (isSkuDataEdited) {
                    isOuterSkuDataEdit = true;
                }

                const updatedSku =
                    matchingRow && matchingRow.sku !== undefined
                        ? matchingRow.sku
                        : skuItem.sku; // Use the SKU from matchingRow or fallback

                const isSkuNameEdited =
                    matchingRow && matchingRow.sku_name !== skuItem.sku_name;

                return {
                    ...skuItem,
                    simplifiedinvoiceskudetails: updatedSkuDetails, // Keep the updated details intact
                    sku_name: matchingRow ? matchingRow.sku_name : skuItem.sku_name,
                    sku: updatedSku, // Include `sku`
                    is_edit: isSkuNameEdited || isSkuDataEdited,
                    is_edit_simplifiedinvoiceskudetails: isSkuDataEdited,
                };
            }
        );

        // Check if updatedSkuData has changed from the original data
        const hasChanges = !currentCardData.simplifiedinvoiceskudata.every(
            (originalSkuItem, index) => {
                const updatedSkuItem = updatedSkuData[index];
                return (
                    originalSkuItem.sku === updatedSkuItem.sku &&
                    originalSkuItem.sku_name === updatedSkuItem.sku_name &&
                    JSON.stringify(originalSkuItem.simplifiedinvoiceskudetails) ===
                    JSON.stringify(updatedSkuItem.simplifiedinvoiceskudetails)
                );
            }
        );

        // If changes are detected, set both edit flags to true
        if (hasChanges) {
            updatedSkuData.forEach((skuItem) => {
                skuItem.is_edit = true;
                skuItem.is_edit_simplifiedinvoiceskudetails = true;
            });
            isOuterSkuDataEdit = true; // Set global edit flag
        }

        // Now, updatedSkuData is ready to be used

        const newAddOnSkuRows = currentCardData.simplifiedinvoiceaddonsku?.map(
            (addOnSkuItem) => {
                const matchingRow = tableDataMap[addOnSkuItem.id]; // Match by `id` instead of `sku_name`
                const updatedDetails = addOnSkuItem.simplifiedinvoiceskudetails.map(
                    (skuDetail) => {
                        const tableValue = matchingRow
                            ? matchingRow[skuDetail.sku_template_field]
                            : undefined;

                        let finalValue = skuDetail.single_input;
                        let singleInputObj = null;

                        if (typeof tableValue === "object" && tableValue !== null) {
                            singleInputObj = tableValue;
                            finalValue = tableValue.value !== undefined ? tableValue.value : "";
                        } else if (
                            typeof skuDetail.single_input === "object" &&
                            skuDetail.single_input !== null
                        ) {
                            singleInputObj = skuDetail.single_input;
                            finalValue =
                                skuDetail.single_input.value !== undefined
                                    ? skuDetail.single_input.value
                                    : "";
                        } else if (tableValue !== undefined) {
                            finalValue = tableValue;
                        }

                        const fieldInfo = currentCardData.assigned_sku_template_field?.find(
                            (f) => f.id === parseInt(skuDetail.sku_template_field)
                        );

                        const headerName = singleInputObj?.headerName || fieldInfo?.name;
                        const type =
                            singleInputObj?.type ||
                            fieldInfo?.type ||
                            skuDetail.sku_template_field_type;
                        const validations =
                            singleInputObj?.validations || fieldInfo?.validations;
                        const is_mandatory =
                            singleInputObj?.is_mandatory ?? fieldInfo?.is_mandatory;

                        return {
                            ...skuDetail,
                            ...(headerName !== undefined && { headerName }),
                            value: finalValue,
                            ...(type !== undefined && { type }),
                            ...(validations !== undefined && { validations }),
                            ...(is_mandatory !== undefined && { is_mandatory }),
                            single_input: finalValue,
                        };
                    }
                );

                currentCardData.assigned_sku_template_field.forEach((field) => {
                    const fieldExists = updatedDetails.some(
                        (detail) => detail.sku_template_field === field.id
                    );

                    if (!fieldExists) {
                        const rawTableVal = matchingRow ? matchingRow[field.id] : "";
                        const valObj =
                            typeof rawTableVal === "object" && rawTableVal !== null
                                ? rawTableVal
                                : {};
                        const tableValue =
                            valObj.value !== undefined ? valObj.value : rawTableVal;

                        updatedDetails.push({
                            sku_template_field: field.id,
                            sku_template_field_type: field.type,
                            sku_template_field_name: field.name,
                            headerName: field.name,
                            value: tableValue || "",
                            type: field.type,
                            validations: field.validations,
                            is_mandatory: field.is_mandatory,
                            single_input: tableValue || "",
                            simplifiedinvoiceskuimageanswer: [],
                        });
                    }
                });

                return {
                    id: addOnSkuItem.id,
                    sku_name: addOnSkuItem.add_on_sku || "", // Use add_on_sku as sku_name
                    sku: matchingRow ? matchingRow.sku : "", // Use SKU from matchingRow or fallback
                    simplifiedinvoiceskudetails: updatedDetails, // Use updated details
                };
            }
        );

        const newRows = tableData
            .filter((row) => row.isNew)
            .map((row) => {
                const matchedSku = results.find(
                    (result) => result.sku_name === row.sku_name
                );

                return {
                    sku_name: row.sku_name || "",
                    sku: matchedSku ? matchedSku.sku : "",
                    simplifiedinvoiceskudetails: Object.entries(row)
                        .filter(([key]) => key !== "id" && key !== "isNew")
                        .map(([key, value]) => {
                            const valObj =
                                typeof value === "object" && value !== null ? value : {};
                            const actualVal =
                                valObj.value !== undefined ? valObj.value : value;
                            const fieldInfo =
                                currentCardData.assigned_sku_template_field?.find(
                                    (f) => f.id === parseInt(key)
                                );
                            return {
                                sku_template_field: key,
                                sku_template_field_name: getFieldName(key),
                                sku_template_field_type: getFieldType(key),
                                headerName:
                                    valObj.headerName || fieldInfo?.name || getFieldName(key),
                                value: actualVal,
                                type: valObj.type || fieldInfo?.type || getFieldType(key),
                                validations: valObj.validations || fieldInfo?.validations,
                                is_mandatory: valObj.is_mandatory ?? fieldInfo?.is_mandatory,
                                single_input: actualVal,
                                simplifiedinvoiceskuimageanswer: [],
                            };
                        }),
                };
            });

        const skuAnswersPayload = [];
        const addonSkusPayload = [];

        const addonSkuMap = (
            currentCardData?.simplifiedinvoiceaddonsku ||
            currentCardData?.add_on_invoice_skus ||
            []
        ).reduce((acc, item) => {
            acc[item.id] = item;
            return acc;
        }, {});

        const skuNameField = (
            currentCardData?.assigned_sku_template_field ||
            cardDataForSKus?.results?.[selectedCard]?.assigned_sku_template_field ||
            []
        ).find((f) => !isSkuNameOcrTemplateField(f) && (isSkuNameTemplateField(f) || f.tag === "sku_name"));
        const skuTemplateId = skuNameField?.id ? parseInt(skuNameField.id, 10) : 30;

        const isSkuNameDetail = (detail) => {
            if (!detail) return false;
            const tag = String(detail.tag || "").toLowerCase().trim();
            if (tag === "sku_name") return true;
            if (isSkuNameOcrTemplateField(detail)) return false;
            const fieldId = detail.sku_template_field || detail.id;
            return (
                fieldId === skuTemplateId ||
                isSkuNameTemplateField(detail) ||
                (detail.name && String(detail.name).toLowerCase().trim() === "sku name") ||
                (detail.headerName && String(detail.headerName).toLowerCase().trim() === "sku name") ||
                (detail.sku_template_field_name && String(detail.sku_template_field_name).toLowerCase().trim() === "sku name")
            );
        };

        tableData.forEach((row) => {
            const isAddonRow = Boolean(row.isAddon || addonSkuMap[row.id] || row.add_on_sku);
            const selectedSkuId = (row.sku !== undefined && row.sku !== null && row.sku !== "")
                ? parseInt(row.sku, 10)
                : ((row.sku_id !== undefined && row.sku_id !== null && row.sku_id !== "") ? parseInt(row.sku_id, 10) : null);
            const initialSkuId = (row.initialSku !== undefined && row.initialSku !== null && row.initialSku !== "")
                ? parseInt(row.initialSku, 10)
                : null;

            const isSkuChanged = Boolean(
                (selectedSkuId && selectedSkuId !== initialSkuId) ||
                (row.sku_name && row.initialSkuName !== undefined && String(row.sku_name).trim() !== String(row.initialSkuName).trim())
            );

            // Add-on SKU row -> include in addon_skus
            if (isAddonRow && selectedSkuId) {
                const rowId = row.id || addonSkuMap[row.id]?.id;
                const parsedId = rowId !== undefined && rowId !== null ? parseInt(rowId, 10) : null;
                if (parsedId) {
                    addonSkusPayload.push({
                        id: isNaN(parsedId) ? rowId : parsedId,
                        sku_id: selectedSkuId,
                        is_qc_edited: true,
                        row_index: row.row_index || 1,
                    });
                }
            }

            const processedAnsIds = new Set();

            Object.entries(row).forEach(([key, val]) => {
                const isTemplateKey = !isNaN(parseInt(key, 10));
                if (
                    isTemplateKey &&
                    key !== "id" &&
                    key !== "isNew" &&
                    key !== "isNewRow" &&
                    key !== "sku_name" &&
                    key !== "add_on_sku" &&
                    key !== "isAddon" &&
                    key !== "sku" &&
                    key !== "sku_id" &&
                    key !== "initialSku" &&
                    key !== "rawDetails" &&
                    key !== "invoice_date"
                ) {
                    const actualVal = typeof val === "object" && val !== null ? val.value : val;
                    const ansId = typeof val === "object" && val !== null ? val.id : null;
                    const origVal = typeof val === "object" && val !== null && val.initialValue !== undefined ? val.initialValue : "";

                    const strVal = actualVal !== undefined && actualVal !== null ? String(actualVal).trim() : "";
                    const strOrig = origVal !== undefined && origVal !== null ? String(origVal).trim() : "";

                    // If regular invoice SKU row had its catalog SKU switched (e.g. 5095 -> 5099)
                    if (!isAddonRow && isSkuChanged) {
                        if (ansId) {
                            const parsedAnsId = parseInt(ansId, 10);
                            const finalAnsId = isNaN(parsedAnsId) ? ansId : parsedAnsId;
                            processedAnsIds.add(finalAnsId);
                            const parsedTemplate = parseInt(key, 10);
                            const answerObj = {
                                id: finalAnsId,
                                sku: selectedSkuId,
                                row_index: row.row_index || 1,
                                is_qc_edited: true
                            };
                            if (!isNaN(parsedTemplate)) {
                                answerObj.sku_template = parsedTemplate;
                            }
                            if (isSkuNameDetail({ id: finalAnsId, sku_template_field: parsedTemplate }) && row.sku_name) {
                                answerObj.single_input = String(row.sku_name).trim();
                            } else if (strVal !== strOrig) {
                                answerObj.single_input = strVal;
                            }
                            skuAnswersPayload.push(answerObj);
                        } else if (strVal !== "") {
                            const parsedTemplate = parseInt(key, 10);
                            const answerObj = {
                                sku: selectedSkuId,
                                sku_template: isNaN(parsedTemplate) ? key : parsedTemplate,
                                row_index: row.row_index || 1,
                                is_qc_edited: true
                            };
                            answerObj.single_input = strVal;
                            skuAnswersPayload.push(answerObj);
                        }
                    } else {
                        // Standard field answer update (or new field answer)
                        if (ansId) {
                            const parsedAnsId = parseInt(ansId, 10);
                            const finalAnsId = isNaN(parsedAnsId) ? ansId : parsedAnsId;
                            processedAnsIds.add(finalAnsId);
                            const parsedTemplate = parseInt(key, 10);
                            if (strVal !== strOrig) {
                                const answerObj = {
                                    id: finalAnsId,
                                    single_input: strVal,
                                    row_index: row.row_index || 1,
                                    is_qc_edited: true
                                };
                                if (selectedSkuId || initialSkuId) {
                                    answerObj.sku = selectedSkuId || initialSkuId;
                                }
                                if (!isNaN(parsedTemplate)) {
                                    answerObj.sku_template = parsedTemplate;
                                }
                                skuAnswersPayload.push(answerObj);
                            }
                        } else if (strVal !== "") {
                            const targetSku = selectedSkuId || initialSkuId;
                            const parsedTemplate = parseInt(key, 10);
                            if (targetSku) {
                                skuAnswersPayload.push({
                                    sku: targetSku,
                                    sku_template: isNaN(parsedTemplate) ? key : parsedTemplate,
                                    single_input: strVal,
                                    row_index: row.row_index || 1,
                                    is_qc_edited: true
                                });
                            } else if (isAddonRow && row.id) {
                                const parsedAddon = parseInt(row.id, 10);
                                skuAnswersPayload.push({
                                    addon_sku: isNaN(parsedAddon) ? row.id : parsedAddon,
                                    sku_template: isNaN(parsedTemplate) ? key : parsedTemplate,
                                    single_input: strVal,
                                    row_index: row.row_index || 1,
                                    is_qc_edited: true
                                });
                            }
                        }
                    }
                }
            });

            // Also ensure any raw details (e.g. from hidden template fields like sku_name) receive updated sku, id, and single_input
            if (isSkuChanged && Array.isArray(row.rawDetails)) {
                row.rawDetails.forEach((detail) => {
                    const dAnsId = detail.id !== undefined && detail.id !== null ? parseInt(detail.id, 10) : null;
                    const finalDAnsId = isNaN(dAnsId) ? detail.id : dAnsId;
                    if (finalDAnsId && !processedAnsIds.has(finalDAnsId)) {
                        processedAnsIds.add(finalDAnsId);
                        const templateFieldId = detail.sku_template_field ? parseInt(detail.sku_template_field, 10) : null;
                        const ansPayload = {
                            id: finalDAnsId,
                            sku: selectedSkuId,
                            row_index: row.row_index || 1,
                            is_qc_edited: true
                        };
                        if (templateFieldId && !isNaN(templateFieldId)) {
                            ansPayload.sku_template = templateFieldId;
                        }
                        if (isSkuNameDetail(detail) && row.sku_name) {
                            ansPayload.single_input = String(row.sku_name).trim();
                            if (!ansPayload.sku_template) {
                                ansPayload.sku_template = skuTemplateId || 30;
                            }
                        } else if (isSkuNameOcrTemplateField(detail)) {
                            ansPayload.single_input = String(detail.single_input || detail.value || "").trim();
                        }
                        skuAnswersPayload.push(ansPayload);
                    }
                });
            }

            // Ensure sku_template: skuTemplateId (defaulting to 30) with single_input, id (if exists), and sku id is passed when SKU changes or on new row
            const isNewRow = Boolean(row.isNew || row.isNewRow);
            if ((isSkuChanged || isNewRow) && selectedSkuId && row.sku_name) {
                const matchedSkuNameDetail = Array.isArray(row.rawDetails)
                    ? row.rawDetails.find((d) => isSkuNameDetail(d))
                    : null;
                const existingSkuNameAnsId = matchedSkuNameDetail?.id
                    ? (isNaN(parseInt(matchedSkuNameDetail.id, 10)) ? matchedSkuNameDetail.id : parseInt(matchedSkuNameDetail.id, 10))
                    : null;

                const targetTemplateId = skuTemplateId || 30;
                const alreadyAddedSkuName = skuAnswersPayload.some(
                    (item) =>
                        (existingSkuNameAnsId && item.id === existingSkuNameAnsId) ||
                        (item.sku === selectedSkuId &&
                            item.sku_template === targetTemplateId &&
                            item.row_index === (row.row_index || 1))
                );

                if (!alreadyAddedSkuName) {
                    const skuNameAnsObj = {
                        sku: selectedSkuId,
                        sku_template: targetTemplateId,
                        single_input: String(row.sku_name).trim(),
                        row_index: row.row_index || 1,
                        is_qc_edited: true
                    };
                    if (existingSkuNameAnsId) {
                        skuNameAnsObj.id = existingSkuNameAnsId;
                    }
                    skuAnswersPayload.push(skuNameAnsObj);
                } else {
                    const existingAns = skuAnswersPayload.find(
                        (item) =>
                            (existingSkuNameAnsId && item.id === existingSkuNameAnsId) ||
                            (item.sku === selectedSkuId &&
                                item.sku_template === targetTemplateId &&
                                item.row_index === (row.row_index || 1))
                    );
                    if (existingAns) {
                        existingAns.single_input = String(row.sku_name).trim();
                        if (!existingAns.sku_template) {
                            existingAns.sku_template = targetTemplateId;
                        }
                    }
                }
            }
        });

        const ocrHeaderAnswers = [];
        localInvoiceHeaders.forEach((item) => {
            const existingAns = findHeaderAnswerInCard(currentCardData?.simplifiedinvoiceheaderanswer, item) ||
                findHeaderAnswerInCard(currentCardData?.invoice_headers, item);

            const ansId = item.answerId || existingAns?.id;
            let newVal = String(item.singleInput ?? "").trim();
            let origVal = String(item.initialSingleInput ?? existingAns?.single_input ?? "").trim();
            const normType = normalizeHeaderType(item.invoiceHeadersTypes || item.type, item.header, item.tag);
            if (normType === "phone_number") {
                if (newVal && !newVal.startsWith("+91") && /^[6-9]\d{9}$/.test(newVal)) {
                    newVal = `+91${newVal}`;
                }
                if (origVal && !origVal.startsWith("+91") && /^[6-9]\d{9}$/.test(origVal)) {
                    origVal = `+91${origVal}`;
                }
            }

            if (ansId) {
                if (newVal !== origVal) {
                    ocrHeaderAnswers.push({
                        id: ansId,
                        single_input: newVal,
                        is_qc_edited: true
                    });
                }
            } else if (newVal !== "") {
                ocrHeaderAnswers.push({
                    invoice_header: item.id,
                    single_input: newVal,
                    is_qc_edited: true
                });
            }
        });

        const ocrPatchPayload = {};

        if (invoiceNo && invoiceNo !== currentCardData?.invoice_no) {
            ocrPatchPayload.invoice_no = invoiceNo;
        }

        if (invoiceDate && invoiceDate !== currentCardData?.invoice_date) {
            ocrPatchPayload.invoice_date = invoiceDate;
        }

        if (ocrHeaderAnswers.length > 0) {
            ocrPatchPayload.header_answers = ocrHeaderAnswers;
        }

        if (skuAnswersPayload.length > 0) {
            ocrPatchPayload.sku_answers = skuAnswersPayload;
        }

        if (addonSkusPayload.length > 0) {
            ocrPatchPayload.addon_skus = addonSkusPayload;
        }

        try {
            if (currentCardData?.id && Object.keys(ocrPatchPayload).length > 0) {
                await updateOcrInvoice(currentCardData.id, ocrPatchPayload);
                if (props.notificationHandler) {
                    props.notificationHandler({
                        messageText: `Invoice saved successfully.`,
                        status: "SUCCESS",
                    });
                }
            }
            setIsFullscreen(false);

            // Mark ONLY this submitted invoice as saved
            const updatedSavedCards = {
                ...savedCards,
                [selectedCard]: true,
                ...(currentCardData?.id ? { [`id_${currentCardData.id}`]: true } : {}),
            };
            setSavedCards(updatedSavedCards);

            const totalCards = cardDataForSKus?.results?.length || 0;
            const allCardsSaved =
                totalCards > 0 &&
                cardDataForSKus?.results?.every(
                    (c, idx) =>
                        Boolean(updatedSavedCards[idx] || (c?.id && updatedSavedCards[`id_${c.id}`]))
                );

            if (props.setIsSliderComplete) {
                props.setIsSliderComplete(Boolean(allCardsSaved));
            }

            if (selectedCard < totalCards - 1) {
                const nextIndex = selectedCard + 1;
                setSelectedCard(nextIndex);
                setErrorIndexes([]);
                setErrorMessages({});
                const nextCardId = cardDataForSKus?.results?.[nextIndex]?.id;
                if (nextCardId) {
                    fetchInvoiceDetail(nextIndex, nextCardId);
                }
            } else {
                if (allCardsSaved) {
                    if (props.onComplete) {
                        props.onComplete();
                    } else if (props.onSaveNext) {
                        props.onSaveNext();
                    }
                    setRefreshData((prev) => !prev);
                } else {
                    const firstUnsavedIndex = cardDataForSKus?.results?.findIndex(
                        (c, idx) =>
                            !Boolean(updatedSavedCards[idx] || (c?.id && updatedSavedCards[`id_${c.id}`]))
                    );
                    if (
                        firstUnsavedIndex !== -1 &&
                        firstUnsavedIndex !== undefined &&
                        firstUnsavedIndex !== selectedCard
                    ) {
                        setSelectedCard(firstUnsavedIndex);
                        setErrorIndexes([]);
                        setErrorMessages({});
                        const unsavedCardId = cardDataForSKus?.results?.[firstUnsavedIndex]?.id;
                        if (unsavedCardId) {
                            fetchInvoiceDetail(firstUnsavedIndex, unsavedCardId);
                        }
                    }
                }
            }
        } catch (error) {
            console.error("Error patching OCR invoice:", error);
            if (props.notificationHandler) {
                props.notificationHandler({
                    messageText: error.message || "Failed to save invoice.",
                    status: "FAILED",
                });
            }
        } finally {
            setEditLoader(false);
        }
    };

    const handleViewImages = () => {
        const currentCardData = cardDataForSKus?.results?.[selectedCard];
        const targetId =
            currentCardData?.workflow_object ||
            props.outletDetails?.workflow_object ||
            props.workflow_object_id ||
            props.outletDetails?.id ||
            props.match?.params?.workflow_object_id ||
            props.match?.params?.id ||
            currentCardData?.id ||
            props.ocrInvoiceId ||
            props.invoiceId;

        const routeTemplate =
            DASHBOARDROUTES.DASHBOARD_INVOICE_DIGITIZATION_IMAGE_VIEWER ||
            DASHBOARDROUTES.DASHBOARD_IMAGE_VIEWER ||
            "/dashboard/collected-bill-image-viewer/:workflow_object_id";

        if (targetId) {
            const url = routeTemplate.replace(":workflow_object_id", targetId);
            window.open(url, "_blank");
        }
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (isSaveShortcut(e)) {
                e.preventDefault();
                e.stopPropagation();
                if (openAddSkuModal || openDialog) {
                    return;
                }
                if (enableEditAnswers && !hasPendingRequests && !hasNewSku && !loading && !editLoader) {
                    handleSaveNext();
                }
            } else if (isTotalImageShortcut(e) || isViewImagesShortcut(e)) {
                e.preventDefault();
                e.stopPropagation();
                handleViewImages();
            } else if (isSaveInvoiceDetailsShortcut(e)) {
                e.preventDefault();
                e.stopPropagation();
                if (enableEditAnswers && !hasPendingRequests) {
                    handleSaveInvoiceHeader();
                }
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [openAddSkuModal, openDialog, enableEditAnswers, hasPendingRequests, hasNewSku, loading, editLoader, handleSaveNext, handleSaveInvoiceHeader, cardDataForSKus, selectedCard, props]);

    const columns = useMemo(() => {
        let firstSkuData =
            cardDataForSKus?.results?.[selectedCard]?.assigned_sku_template_field ||
            cardDataForSKus?.results?.[selectedCard]?.sku_template_headers;
        if (!Array.isArray(firstSkuData) || firstSkuData.length === 0) {
            firstSkuData = defaultAssignedSkuFields;
        }
        setInvoiceNo(cardDataForSKus?.results[selectedCard]?.invoice_no);
        setInvoiceDate(cardDataForSKus?.results[selectedCard]?.invoice_date)
        const seenHeaders = new Set();
        return [
            {
                Header: "SKU Name", // Always have "SKU Name" as the first column
                accessor: "sku_name",
                type: "text",
                otherData: null
            },
            // Filter out master SKU Name template field since the first column is already "SKU Name" dropdown
            ...(firstSkuData?.filter((detail) => !isSkuNameTemplateField(detail)).map((detail) => {
                if (!detail) return null; // Handle undefined detail
                // Using `name` (or other relevant field) as the unique header
                let uniqueHeader = detail.name || `Detail ${detail.id}`;
                let accessor = detail.id?.toString() || "undefined_id";
                let type = detail.type || detail.template_type || "text";
                let otherData = detail.validations;
                let is_mandatory = detail.is_mandatory;

                // Handle duplicate accessor keys
                let index = 1;
                while (seenHeaders.has(accessor)) {
                    accessor = `${uniqueHeader}_${index}`;
                    index++;
                }
                seenHeaders.add(accessor);

                return {
                    Header: uniqueHeader, // Display field name as header
                    accessor: accessor, // Key for accessing this field's value
                    type: type,
                    validations: otherData,
                    is_mandatory: is_mandatory
                };
            }) || []),
        ];
    }, [selectedCard, cardDataForSKus]);

    const totalMrp = useMemo(() => {
        if (!tableData || tableData.length === 0) return 0;
        const mrpCol = columns.find(
            (col) => col && col.Header && col.Header.toString().trim().toUpperCase() === "MRP"
        );
        if (!mrpCol) return 0;
        const colId = mrpCol.accessor;
        return tableData.reduce((sum, row) => {
            const rawVal =
                row[colId]?.value !== undefined ? row[colId].value : row[colId];
            const num = parseFloat(rawVal);
            return sum + (isNaN(num) ? 0 : num);
        }, 0);
    }, [tableData, columns]);

    const data = useMemo(() => {
        const currentResults = cardDataForSKus?.results[selectedCard] || {};


        console.log("currentResults------>>>>", JSON.stringify(currentResults));


        // Function to map data for both sku types, with conditional key for add_on_sku and including the id
        // const mapSkuData = (skuDataArray, invoiceDate, isAddon = false) =>

        //   skuDataArray?.map((skuData) => ({
        //     id: skuData.id, // Include the id field
        //     sku: skuData.sku,
        //     [isAddon ? "add_on_sku" : "sku_name"]: isAddon
        //       ? skuData.add_on_sku
        //       : skuData.sku_name,
        //     invoice_date: invoiceDate,
        //     ...skuData.simplifiedinvoiceskudetails.reduce(
        //       (acc, detail) => ({
        //         ...acc,
        //         [detail.sku_template_field.toString()]: {
        //           headerName:detail.sku_template_field_name,
        //           value: detail.single_input,
        //           type: detail.sku_template_field_type,
        //           validations: detail.validations,
        //           is_mandatory:detail.is_mandatory,
        //         },
        //       }),
        //       {}
        //     ),
        //   })) || [];


        const mapSkuData = (skuDataArray, invoiceDate, isAddon = false) => {
            const assignedFields = currentResults.assigned_sku_template_field || defaultAssignedSkuFields;
            return skuDataArray?.map((skuData) => {
                const detailMap = (skuData.simplifiedinvoiceskudetails || []).reduce((acc, detail) => {
                    acc[detail.sku_template_field] = detail;
                    return acc;
                }, {});

                const fullDetails = (assignedFields || []).reduce((acc, field) => {
                    const matchedDetail = detailMap[field.id];
                    const isPackshot = isPackshotImageField(field);
                    let sanitizedInput = "";

                    if (isPackshot) {
                        const hasImg = Boolean(
                            matchedDetail?.has_image_answer ||
                            matchedDetail?.image_answer ||
                            (Array.isArray(matchedDetail?.simplifiedinvoiceskuimageanswer) && matchedDetail.simplifiedinvoiceskuimageanswer.length > 0)
                        );
                        sanitizedInput = hasImg ? "Image Answered" : "";
                    } else {
                        const rawSingleInput = matchedDetail?.single_input ?? matchedDetail?.value ?? "";
                        sanitizedInput = rawSingleInput !== undefined && rawSingleInput !== null ? String(rawSingleInput).trim() : "";
                        const isFieldAutoSku = isAutoPopulatedDisabledSkuField(field);
                        if (isFieldAutoSku && !sanitizedInput && skuData.sku_name) {
                            sanitizedInput = String(skuData.sku_name).trim();
                        }
                        const normType = normalizeTemplateType(field.type, field.name);
                        if (normType === "integer" && sanitizedInput) {
                            const match = sanitizedInput.match(/-?\d+/);
                            sanitizedInput = match ? match[0] : sanitizedInput.replace(/[^0-9]/g, "");
                        } else if (normType === "decimal" && sanitizedInput) {
                            const match = sanitizedInput.match(/-?\d+(\.\d+)?/);
                            sanitizedInput = match ? match[0] : sanitizedInput.replace(/[^0-9.]/g, "");
                        }
                    }

                    acc[field.id.toString()] = {
                        id: matchedDetail?.id || null,
                        headerName: field.name,
                        value: sanitizedInput,
                        initialValue: sanitizedInput,
                        type: field.type,
                        validations: field.validations,
                        is_mandatory: field.is_mandatory,
                        is_mt_edited: Boolean(matchedDetail?.is_mt_edited),
                        is_qc_edited: Boolean(matchedDetail?.is_qc_edited),
                        is_reviewed: Boolean(matchedDetail?.is_reviewed),
                        image_answer: matchedDetail?.image_answer || null,
                        has_image_answer: Boolean(matchedDetail?.has_image_answer || matchedDetail?.image_answer),
                        files_details: matchedDetail?.files_details || [],
                        simplifiedinvoiceskuimageanswer: matchedDetail?.simplifiedinvoiceskuimageanswer || [],
                    };
                    return acc;
                }, {});

                const initialSkuVal = skuData.sku !== undefined && skuData.sku !== null && skuData.sku !== ""
                    ? parseInt(skuData.sku, 10)
                    : null;
                const rowIndexVal = skuData.row_index !== undefined && skuData.row_index !== null
                    ? parseInt(skuData.row_index, 10)
                    : (skuData.simplifiedinvoiceskudetails?.[0]?.row_index !== undefined ? parseInt(skuData.simplifiedinvoiceskudetails[0].row_index, 10) : 1);

                return {
                    id: skuData.id,
                    sku: skuData.sku,
                    initialSku: initialSkuVal,
                    initialSkuName: isAddon ? (skuData.sku_name || "") : (skuData.sku_name || ""),
                    row_index: isNaN(rowIndexVal) ? 1 : rowIndexVal,
                    rawDetails: skuData.simplifiedinvoiceskudetails || [],
                    sku_name: isAddon ? (skuData.sku_name || "") : (skuData.sku_name || ""),
                    is_mt_edited: Boolean(skuData.is_mt_edited),
                    is_qc_edited: Boolean(skuData.is_qc_edited),
                    is_reviewed: Boolean(skuData.is_reviewed),
                    ...(isAddon && { add_on_sku: skuData.add_on_sku || true }),
                    isAddon: Boolean(isAddon),
                    invoice_date: invoiceDate,
                    ...fullDetails,
                };
            }) || [];
        };

        // Map both simplifiedinvoiceskudata and simplifiedinvoiceaddonsku
        const currentSkuData = mapSkuData(
            currentResults.simplifiedinvoiceskudata,
            currentResults.invoice_date
        );

        const currentAddonSkuData = mapSkuData(
            currentResults.simplifiedinvoiceaddonsku,
            currentResults.invoice_date,
            true
        );

        // Combine both data sets
        const combinedData = [...currentSkuData, ...currentAddonSkuData];

        return combinedData;
    }, [selectedCard, columns, cardDataForSKus]);


    console.log("data------>>>>", JSON.stringify(data));

    const addEmptyRow = () => {
        const emptyRow = {
            id: Date.now(), // Unique identifier using timestamp or you can use a UUID library
            isNew: true, // Flag to indicate it's a new row
        };

        columns.forEach((column) => {
            if (column.validations != null) {
                emptyRow[column.accessor] = {
                    headerName: column.Header,
                    value: "",
                    type: column.type,
                    validations: column?.validations || null,
                    is_mandatory: column?.is_mandatory,

                }; // Set each key to an empty string  
            } else {
                emptyRow[column.accessor] = ""
            }
        });


        setTableData((prevData) => [...prevData, emptyRow]);
    };

    const handleOpenAddSkuModal = () => {
        const initialForm = { sku_name: "" };
        columns.forEach((col) => {
            if (col.accessor !== "sku_name") {
                initialForm[col.accessor] = "";
            }
        });
        setNewSkuFormData(initialForm);
        setAddSkuModalErrors({});
        setAddSkuSearchInput("");
        setSkuSearchText("");
        setSkuPage(1);
        setOpenAddSkuModal(true);
    };

    const handleCloseAddSkuModal = () => {
        setOpenAddSkuModal(false);
        setNewSkuFormData({});
        setAddSkuModalErrors({});
        setAddSkuSearchInput("");
        setSkuSearchText("");
        setSkuPage(1);
    };

    const handleAddSkuInputChange = (accessor, value) => {
        let finalVal = value;
        const colDef = columns.find((c) => c.accessor === accessor);
        const headerName = colDef?.Header || accessor;
        const normType = normalizeTemplateType(colDef?.type, headerName);

        if (typeof finalVal === "string") {
            if (normType === "integer") {
                finalVal = finalVal.replace(/[^0-9]/g, "");
            } else if (normType === "decimal") {
                finalVal = finalVal.replace(/[^0-9.]/g, "");
                const parts = finalVal.split(".");
                if (parts.length > 2) {
                    finalVal = parts[0] + "." + parts.slice(1).join("");
                }
                if (finalVal.startsWith(".")) {
                    finalVal = "0" + finalVal;
                }
            }
        }

        setNewSkuFormData((prev) => ({
            ...prev,
            [accessor]: finalVal,
        }));
        if (addSkuModalErrors[accessor]) {
            setAddSkuModalErrors((prev) => {
                const updated = { ...prev };
                delete updated[accessor];
                return updated;
            });
        }
    };

    const handleSaveAddSku = () => {
        const errors = {};

        if (!newSkuFormData.sku_name || !newSkuFormData.sku_name.trim()) {
            errors.sku_name = "SKU Name is required";
        }

        if (addSkuModalErrors.sku_name) {
            setAddSkuModalErrors((prev) => {
                const updated = { ...prev };
                delete updated.sku_name;
                return updated;
            });
        }

        columns.forEach((col) => {
            if (col.accessor === "sku_name") return;
            if (isAutoPopulatedDisabledSkuField(col) && !newSkuFormData[col.accessor] && newSkuFormData.sku_name) {
                newSkuFormData[col.accessor] = newSkuFormData.sku_name.trim();
            }
            const rawVal = newSkuFormData[col.accessor];
            let val = rawVal !== undefined && rawVal !== null ? String(rawVal).trim() : "";
            const isMandatory = col.is_mandatory;
            const headerName = col.Header || col.accessor;
            const normType = normalizeTemplateType(col.type, headerName);

            if (typeof val === "string") {
                if (normType === "decimal") {
                    if (val.startsWith(".")) {
                        val = "0" + val;
                        newSkuFormData[col.accessor] = val;
                    }
                }
            }

            if (!val) {
                if (isMandatory && !isDisabledSkuField(col)) {
                    errors[col.accessor] = `${headerName} is required`;
                }
                return;
            }

            if (normType === "text") {
                if (col.validations?.min_length && val.length < parseInt(col.validations.min_length, 10)) {
                    errors[col.accessor] = `${headerName} must be at least ${col.validations.min_length} characters`;
                }
                if (col.validations?.max_length && val.length > parseInt(col.validations.max_length, 10)) {
                    errors[col.accessor] = `${headerName} must not exceed ${col.validations.max_length} characters`;
                }
            } else if (normType === "integer") {
                if (val.startsWith("-") || parseInt(val, 10) < 0) {
                    errors[col.accessor] = `${headerName} cannot be negative`;
                } else if (val.includes(".") || !/^\d+$/.test(val)) {
                    errors[col.accessor] = `${headerName} must be a number`;
                } else if (isNaN(parseInt(val, 10))) {
                    errors[col.accessor] = `${headerName} must be a valid whole number`;
                }
            } else if (normType === "decimal") {
                if (val.startsWith("-") || parseFloat(val) < 0) {
                    errors[col.accessor] = `${headerName} cannot be negative`;
                } else if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(val) || isNaN(parseFloat(val))) {
                    errors[col.accessor] = `${headerName} must be a valid number`;
                }
            } else if (normType === "date") {
                if (isNaN(Date.parse(val))) {
                    errors[col.accessor] = `${headerName} must be a valid date`;
                }
            }
        });

        if (Object.keys(errors).length > 0) {
            setAddSkuModalErrors(errors);
            return;
        }

        const currentCardData = cardDataForSKus?.results?.[selectedCard];
        const skuNameField = (
            currentCardData?.assigned_sku_template_field ||
            []
        ).find((f) => !isSkuNameOcrTemplateField(f) && (isSkuNameTemplateField(f) || f.tag === "sku_name"));
        const skuTemplateId = skuNameField?.id ? parseInt(skuNameField.id, 10) : 30;

        const newRow = {
            id: Date.now(),
            isNew: true,
            isNewRow: true,
            sku_name: newSkuFormData.sku_name?.trim() || "",
            sku: newSkuFormData.sku !== undefined && newSkuFormData.sku !== null ? newSkuFormData.sku : null,
            sku_id: newSkuFormData.sku !== undefined && newSkuFormData.sku !== null ? newSkuFormData.sku : null,
            initialSku: null,
            [String(skuTemplateId)]: {
                headerName: skuNameField?.name || "SKU Name",
                value: newSkuFormData.sku_name?.trim() || "",
                type: "text",
                is_mandatory: false,
            },
            ...(newSkuFormData.add_on_sku?.trim() && { add_on_sku: newSkuFormData.add_on_sku.trim() }),
        };

        columns.forEach((column) => {
            if (column.accessor !== "sku_name") {
                const isColAutoSku = isAutoPopulatedDisabledSkuField(column);
                const val = isColAutoSku
                    ? (newSkuFormData.sku_name?.trim() || newSkuFormData[column.accessor] || "")
                    : (newSkuFormData[column.accessor] !== undefined ? newSkuFormData[column.accessor] : "");
                newRow[column.accessor] = {
                    headerName: column.Header,
                    value: val,
                    type: column.type,
                    validations: column.validations || null,
                    is_mandatory: column.is_mandatory,
                };
            }
        });

        const targetSkuId = newSkuFormData.sku !== undefined && newSkuFormData.sku !== null ? String(newSkuFormData.sku).trim() : "";
        const targetSkuName = (newSkuFormData.sku_name || "").toString().trim().toLowerCase();
        const targetAddonName = (newSkuFormData.add_on_sku || "").toString().trim().toLowerCase();

        const existingRowsWithSku = tableData.filter((r) => {
            const rSkuId = (r.sku !== undefined && r.sku !== null && r.sku !== "")
                ? String(r.sku).trim()
                : ((r.sku_id !== undefined && r.sku_id !== null && r.sku_id !== "") ? String(r.sku_id).trim() : "");
            const rSkuName = (r.sku_name || "").toString().trim().toLowerCase();
            const rAddonName = (r.add_on_sku || "").toString().trim().toLowerCase();

            const idMatches = Boolean(targetSkuId && rSkuId && targetSkuId === rSkuId);
            const nameMatches = Boolean(targetSkuName && (rSkuName === targetSkuName || rAddonName === targetSkuName));
            const addonMatches = Boolean(targetAddonName && (rAddonName === targetAddonName || rSkuName === targetAddonName));

            return idMatches || nameMatches || addonMatches;
        });

        let calculatedRowIndex = 1;
        if (existingRowsWithSku.length === 0) {
            calculatedRowIndex = 1;
        } else if (existingRowsWithSku.length > 0) {
            const largestRowIndex = Math.max(...existingRowsWithSku.map((r) => Number(r.row_index) || 1));
            calculatedRowIndex = largestRowIndex + 1;
        }
        newRow.row_index = calculatedRowIndex;

        setTableData((prevData) => [...prevData, newRow]);
        handleCloseAddSkuModal();

        if (props.notificationHandler) {
            props.notificationHandler({
                messageText: "New SKU added to list successfully.",
                status: "SUCCESS",
            });
        }
    };

    useEffect(() => {
        // Initialize the tableData when data changes
        setTableData(data);
        setSelectedRowIndices([]);
    }, [data]);

    useEffect(() => {
        setSelectedRowIndices([]);
    }, [selectedCard]);
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
        useTable({
            columns,
            data: tableData,
        });

    const isNumeric = (value) => {
        return !isNaN(value) && !isNaN(parseFloat(value));
    };

    const handleInputChange = (event, rowIndex, columnId, value, type, isCellNumberPaste = false) => {
        let rawValue = isCellNumberPaste === false ? (value !== undefined ? value : event?.target?.value) : value;
        const colDef = columns.find((c) => c.accessor === columnId || String(c.id) === String(columnId));
        const headerName = colDef?.Header || columnId;
        const normType = normalizeTemplateType(type || colDef?.type, headerName);

        let newValue = rawValue;
        if (typeof newValue === "string") {
            if (normType === "integer") {
                newValue = newValue.replace(/[^0-9]/g, "");
            } else if (normType === "decimal") {
                newValue = newValue.replace(/[^0-9.]/g, "");
                const parts = newValue.split(".");
                if (parts.length > 2) {
                    newValue = parts[0] + "." + parts.slice(1).join("");
                }
                if (newValue.startsWith(".")) {
                    newValue = "0" + newValue;
                }
            }
        }

        setTableData((prevData) => {
            const updatedData = [...prevData];
            const currentCell = updatedData[rowIndex]?.[columnId];

            if (typeof currentCell === "object" && currentCell !== null) {
                updatedData[rowIndex] = {
                    ...updatedData[rowIndex],
                    [columnId]: {
                        ...currentCell,
                        value: newValue,
                    },
                };
            } else {
                updatedData[rowIndex] = {
                    ...updatedData[rowIndex],
                    [columnId]: {
                        headerName: colDef?.Header || columnId,
                        value: newValue,
                        type: type || "text",
                    },
                };
            }

            return updatedData;
        });

        setValidationErrors((prevErrors) =>
            prevErrors.filter(
                (err) => !(err.rowIndex === rowIndex && String(err.columnId) === String(columnId))
            )
        );
    };

    const newAddedSKuTest = newAddedSKu?.results ?? [];

    const sliderSettings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
    };

    const findHeaderAnswerInCard = (answersList, headerItem) => {
        if (!Array.isArray(answersList)) return null;
        const targetId = String(headerItem?.id ?? headerItem?.invoice_header ?? "");
        const targetName = (headerItem?.header || headerItem?.name || "").trim().toLowerCase();

        return answersList.find((ans) => {
            if (!ans) return false;
            const ansId = String(ans.id ?? "");
            const ansHeaderId = String(
                typeof ans.invoice_header === "object"
                    ? ans.invoice_header?.id
                    : ans.invoice_header ?? ""
            );
            const ansHeaderName = (
                ans.invoice_header_name ||
                (typeof ans.invoice_header === "object" ? ans.invoice_header?.name : "") ||
                ""
            ).trim().toLowerCase();

            return (
                (headerItem?.answerId && ansId === String(headerItem.answerId)) ||
                (targetId && ansHeaderId === targetId) ||
                (targetName && ansHeaderName === targetName)
            );
        });
    };

    const getInvoiceHeaders = (data, index) => {
        let assignedFields = data?.results?.[index]?.assign_simplifiedinvoiceheader_field;
        const answers = data?.results?.[index]?.simplifiedinvoiceheaderanswer;

        if (!Array.isArray(assignedFields) || assignedFields.length === 0) {
            assignedFields = defaultAssignedHeaderFields;
        }

        return assignedFields.map((assignedItem) => {
            const matchedAnswer = findHeaderAnswerInCard(answers, assignedItem);
            const rawSingleInput = matchedAnswer?.single_input ?? "";
            const normType = normalizeHeaderType(
                assignedItem?.header_type || assignedItem?.type || "",
                assignedItem?.name,
                assignedItem?.tag || matchedAnswer?.tag
            );

            let initialSingleInput = rawSingleInput;
            if (normType === "phone_number" && typeof rawSingleInput === "string") {
                let digits = rawSingleInput.replace(/[^0-9]/g, "");
                if (digits.length > 10 && digits.startsWith("91")) {
                    digits = digits.slice(2);
                }
                initialSingleInput = digits.slice(0, 10);
            }

            return {
                header: assignedItem?.name,
                singleInput: initialSingleInput,
                initialSingleInput: initialSingleInput,
                id: assignedItem?.id,
                answerId: matchedAnswer?.id || null,
                is_mt_edited: Boolean(matchedAnswer?.is_mt_edited ?? assignedItem?.is_mt_edited),
                is_qc_edited: Boolean(matchedAnswer?.is_qc_edited ?? assignedItem?.is_qc_edited),
                is_reviewed: Boolean(matchedAnswer?.is_reviewed ?? assignedItem?.is_reviewed),
                invoiceHeaderValidation: assignedItem?.validations || [],
                show_logic_config: assignedItem?.show_logic_config || null,
                invoiceHeadersTypes: assignedItem?.header_type || assignedItem?.type || "",
                tag: assignedItem?.tag || matchedAnswer?.tag || "",
                is_mandatory: assignedItem?.is_mandatory || false,
                type: matchedAnswer?.invoice_header_type || assignedItem?.header_type || assignedItem?.type || "",
                simplifiedinvoiceheaderanswerdetails: Array.isArray(matchedAnswer?.simplifiedinvoiceheaderanswerdetails)
                    ? matchedAnswer.simplifiedinvoiceheaderanswerdetails.map((detail) => ({
                        gst_legal_name: detail?.gst_legal_name,
                        gst_registration_status: detail?.gst_registration_status,
                        gst_trade_name: detail?.gst_trade_name,
                        pan_holder_name: detail?.pan_holder_name,
                    }))
                    : [],
            };
        });
    };

    const invoiceHeaders = useMemo(
        () => getInvoiceHeaders(cardDataForSKus, selectedCard),
        [cardDataForSKus, selectedCard]
    );


    useEffect(() => {
        console.log(`Testing setLocalInvoiceHeaders > 2 >> >> >${JSON.stringify(invoiceHeaders)}`);
        setLocalInvoiceHeaders([...invoiceHeaders]);
    }, [invoiceHeaders]);

    const handleSingleInputChange = (e, id) => {
        const value = e.target.value;

        let formattedValue = value;
        if (e.target.type === "date") {
            if (!value) {
                formattedValue = "";
            } else {
                const inputDate = new Date(value);
                if (!isNaN(inputDate.getTime())) {
                    formattedValue = inputDate.toISOString().split("T")[0];
                } else {
                    formattedValue = value;
                }
            }
        }

        if (e.target.type === "time") {
            const timeToCheck = moment(value, "HH:mm").format("YYYY-MM-DD HH:mm:ss");
            const timeMoment = moment(timeToCheck, "YYYY-MM-DD HH:mm:ss");

            const startTime = moment("10:00", "HH:mm").format("YYYY-MM-DD HH:mm:ss");
            const startMoment = moment(startTime, "YYYY-MM-DD HH:mm:ss");

            const endTime = moment("19:00", "HH:mm").format("YYYY-MM-DD HH:mm:ss");
            const endMoment = moment(endTime, "YYYY-MM-DD HH:mm:ss");

            formattedValue = timeMoment.format("HH:mm:ss");
        }

        const matchedHeader = localInvoiceHeaders.find((item) => item.id === id);
        const headerName = matchedHeader?.header || "";
        const normHdrType = normalizeHeaderType(matchedHeader?.invoiceHeadersTypes || matchedHeader?.type, headerName, matchedHeader?.tag);

        if (normHdrType === "gstin" && typeof formattedValue === "string") {
            formattedValue = formattedValue.toUpperCase().replace(/[^0-9A-Z]/g, "").slice(0, 15);
        }

        if (normHdrType === "pan_number" && typeof formattedValue === "string") {
            formattedValue = formattedValue.toUpperCase().replace(/[^0-9A-Z]/g, "").slice(0, 10);
        }

        if (normHdrType === "phone_number" && typeof formattedValue === "string") {
            let clean = formattedValue.replace(/[^0-9]/g, "");
            if (clean.length > 10 && clean.startsWith("91")) {
                clean = clean.slice(2);
            }
            formattedValue = clean.slice(0, 10);
        }

        if (normHdrType === "integer" && typeof formattedValue === "string") {
            formattedValue = formattedValue.replace(/[^0-9]/g, "");
        } else if (normHdrType === "decimal" && typeof formattedValue === "string") {
            formattedValue = formattedValue.replace(/[^0-9.]/g, "");
            const parts = formattedValue.split(".");
            if (parts.length > 2) {
                formattedValue = parts[0] + "." + parts.slice(1).join("");
            }
            if (formattedValue.startsWith(".")) {
                formattedValue = "0" + formattedValue;
            }
        }

        const updatedHeaders = localInvoiceHeaders.map((item) => {
            if (item.id === id) {
                const itemNormType = normalizeHeaderType(item.invoiceHeadersTypes || item.type);
                return {
                    ...item,
                    singleInput: formattedValue,
                    ...(itemNormType === "gstin" && {
                        isVerified: false,
                        simplifiedinvoiceheaderanswerdetails: item.simplifiedinvoiceheaderanswerdetails?.map((i) => ({
                            ...i,
                            gst_legal_name: "",
                            gst_trade_name: "",
                            gst_registration_status: "",
                        })),
                    }),
                    ...(itemNormType === "pan_number" && {
                        isVerified: false,
                        simplifiedinvoiceheaderanswerdetails: item.simplifiedinvoiceheaderanswerdetails?.map((i) => ({
                            ...i,
                            pan_holder_name: "",
                        })),
                    }),
                };
            }
            return item;
        });

        console.log(`Testing setLocalInvoiceHeaders > 1 >> >> >${JSON.stringify(updatedHeaders)}`);

        const finalHeaders = updatedHeaders.map((item) =>
            item.show_logic_config?.show_logic_invoice_header === id
                ? {
                    ...item,
                    singleInput: "",
                    isVerified: false,
                    simplifiedinvoiceheaderanswerdetails: [],
                }
                : item
        );

        setLocalInvoiceHeaders(finalHeaders);
        props.setIsSliderComplete(false);

        // setLocalInvoiceHeaders(updatedHeaders);

        if (formattedValue && formattedValue.trim() !== "") {
            setErrorIndexes((prev) => prev.filter((i) => i !== id));
        }
    };



    const handleActionButtonClick = (details) => {
        const index = localInvoiceHeaders.findIndex((data) => data.id === details.id);

        const { notificationHandler } = props;
        const updatedHeaders = [...localInvoiceHeaders];


        const req = `?input=${updatedHeaders[index].singleInput}&input_type=GST`;

        getGstAndPanDetails(req)
            .then((response) => {
                // Extract GST details from response
                const gstLegalName = response.lgnm || "";
                const gstTradeName = response.tradeNam || "";
                const gstRegistrationStatus = response.dty || "";

                // If simplifiedinvoiceheaderanswerdetails is empty, initialize it
                if (!updatedHeaders[index].simplifiedinvoiceheaderanswerdetails.length) {
                    updatedHeaders[index].simplifiedinvoiceheaderanswerdetails = [{
                        gst_legal_name: gstLegalName,
                        gst_trade_name: gstTradeName,
                        gst_registration_status: gstRegistrationStatus,
                    }];
                } else {
                    updatedHeaders[index].simplifiedinvoiceheaderanswerdetails =
                        updatedHeaders[index].simplifiedinvoiceheaderanswerdetails.map((item) => ({
                            ...item,
                            gst_legal_name: gstLegalName || item.gst_legal_name,
                            gst_trade_name: gstTradeName || item.gst_trade_name,
                            gst_registration_status: gstRegistrationStatus || item.gst_registration_status,
                        }));
                }

                // Mark as verified if all required fields are filled
                const isVerified = updatedHeaders[index].simplifiedinvoiceheaderanswerdetails.every(
                    (item) =>
                        item.gst_legal_name &&
                        item.gst_trade_name &&
                        item.gst_registration_status
                );
                updatedHeaders[index].isVerified = isVerified;
                console.log(`Testing setLocalInvoiceHeaders > 3`);
                setLocalInvoiceHeaders([...updatedHeaders]);

                notificationHandler({
                    messageText: `GST number validated successfully.`,
                    status: "SUCCESS",
                });
            })
            .catch((error) => {
                notificationHandler({
                    messageText: `Invalid GST format. The given GST number is not in the proper format.`,
                    status: "FAILED",
                });
            });
    };


    const handlePanButtonClick = (details) => {
        const index = localInvoiceHeaders.findIndex((data) => data.id === details.id);

        const { notificationHandler } = props;
        const updatedHeaders = [...localInvoiceHeaders];
        const req = `?input=${updatedHeaders[index].singleInput}&input_type=PAN`;

        console.log(`localInvoiceHeaders ${index} > ${JSON.stringify(updatedHeaders[index])}`);

        getGstAndPanDetails(req)
            .then((response) => {
                if (response?.error) {
                    notificationHandler({
                        messageText: response.error,
                        status: "FAILED",
                    });
                    return;
                }
                // Extract PAN holder name from response
                const panHolderName = response.name || response.name_on_card || "";
                // If simplifiedinvoiceheaderanswerdetails is empty, initialize it
                if (!updatedHeaders[index].simplifiedinvoiceheaderanswerdetails.length) {
                    updatedHeaders[index].simplifiedinvoiceheaderanswerdetails = [{
                        pan_holder_name: panHolderName,
                    }];
                } else {
                    updatedHeaders[index].simplifiedinvoiceheaderanswerdetails =
                        updatedHeaders[index].simplifiedinvoiceheaderanswerdetails.map((item) => ({
                            ...item,
                            pan_holder_name: panHolderName || item.pan_holder_name,
                        }));
                }

                // Mark as verified if all entries have a pan_holder_name
                const isVerified = updatedHeaders[index].simplifiedinvoiceheaderanswerdetails.every(
                    (item) => item.pan_holder_name
                );
                updatedHeaders[index].isVerified = isVerified;
                console.log(`Testing setLocalInvoiceHeaders > 4`);
                setLocalInvoiceHeaders([...updatedHeaders]);
                notificationHandler({
                    messageText: `PAN number validated successfully.`,
                    status: "SUCCESS",
                });
            })
            .catch((error) => {
                notificationHandler({
                    messageText: `Invalid PAN number. The given PAN number is not in the proper format or invalid.`,
                    status: "FAILED",
                });
            });
    };


    const validateInvoiceHeadersAnswer = (invoiceHeaderId) => {

        return cardDataForSKus?.results[selectedCard].simplifiedinvoiceheaderanswer
            ?.some(item => item.invoice_header === invoiceHeaderId);
    }


    const handleSaveInvoiceHeader = async () => {
        const { notificationHandler } = props;

        const errors = [];
        const errorMsgs = {};

        localInvoiceHeaders
            .filter((item) => !isInvoiceNoOrDate(item))
            .forEach((detail, index) => {
                const value = detail.singleInput ? String(detail.singleInput).trim() : "";
                const rawType = detail.invoiceHeadersTypes || detail.type || "";
                const invoiceHeaderType = normalizeHeaderType(rawType);
                const isMandatory = detail.is_mandatory;
                const show_logic_config = detail.show_logic_config;
                let isShowLogic = false;
                let isShowLogicConditionMet = false;

                const {
                    min_length,
                    max_length,
                    greater_than,
                    lower_than,
                    lower_limit,
                    upper_limit,
                    allow_decimals,
                    min_images_count,
                    max_images_count,
                    choices,
                } = detail.invoiceHeaderValidation || {};

                if (isMandatory) {

                    if (show_logic_config && show_logic_config.show_logic_invoice_header != null) {

                        isShowLogic = true;

                        const showLogicHeaderData = localInvoiceHeaders.find(item => item.id === show_logic_config.show_logic_invoice_header);
                        if (showLogicHeaderData && showLogicHeaderData.singleInput?.trim().length > 0) {
                            if (show_logic_config.show_logic_invoice_condition == "is_equal_to") {
                                if (showLogicHeaderData.singleInput?.trim() == show_logic_config.show_logic_option || showLogicHeaderData.singleInput?.trim() == show_logic_config.show_logic_invoice_option) {
                                    isShowLogicConditionMet = true;
                                    if (value === "") {
                                        errors.push(index);
                                        errorMsgs[index] = `${detail.header} cannot be empty.`;
                                        return;
                                    }
                                }
                            }

                            if (show_logic_config.show_logic_invoice_condition == "is_not_equal_to") {
                                if (showLogicHeaderData.singleInput?.trim() != show_logic_config.show_logic_option && showLogicHeaderData.singleInput?.trim() != show_logic_config.show_logic_invoice_option) {
                                    isShowLogicConditionMet = true;
                                    if (value === "") {
                                        errors.push(index);
                                        errorMsgs[index] = `${detail.header} cannot be empty.`;
                                        return;
                                    }
                                }
                            }
                        }

                    } else {
                        if (value === "") {
                            errors.push(index);
                            errorMsgs[index] = `${detail.header} cannot be empty.`;
                            return;
                        }
                    }
                } else {
                    if (value === "") {
                        return; // Skip further validation for non-mandatory fields if empty
                    }
                }

                switch (invoiceHeaderType) {
                    case "text":
                        if (min_length && value.length < parseInt(min_length, 10)) {
                            errors.push(index);
                            errorMsgs[index] = `${detail.header} must be at least ${min_length} characters.`;
                        } else if (max_length && value.length > parseInt(max_length, 10)) {
                            errors.push(index);
                            errorMsgs[index] = `${detail.header} must not exceed ${max_length} characters.`;
                        }
                        break;

                    case "integer":
                    case "decimal":
                    case "number":
                        const isIntegerHeader = invoiceHeaderType === "integer";

                        const validateNumberField = (val) => {
                            let formattedVal = val;
                            if (!isIntegerHeader) {
                                if (formattedVal.startsWith(".")) {
                                    formattedVal = "0" + formattedVal;
                                    detail.singleInput = formattedVal;
                                }
                            }

                            if (/[a-zA-Z]/.test(formattedVal)) {
                                return `${detail.header} must only contain numbers (alphabetic characters are not allowed).`;
                            }

                            if (formattedVal.startsWith("-")) {
                                return `${detail.header} cannot be negative.`;
                            }

                            if (isIntegerHeader) {
                                if (formattedVal.includes(".") || !/^\d+$/.test(formattedVal)) {
                                    return `${detail.header} cannot be in decimal and must be a whole number.`;
                                }
                            } else {
                                if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(formattedVal)) {
                                    return `${detail.header} must be a valid number.`;
                                }
                                if (allow_decimals === false && formattedVal.includes(".")) {
                                    return `${detail.header} must be an integer.`;
                                }
                            }
                            const numericValue = parseFloat(formattedVal);
                            if (isNaN(numericValue) || numericValue < 0) {
                                return `${detail.header} cannot be negative.`;
                            }
                            const lowerLimit = lower_limit ? parseFloat(lower_limit) : null;
                            const upperLimit = upper_limit ? parseFloat(upper_limit) : null;
                            if (lowerLimit !== null && numericValue < lowerLimit) {
                                return `${detail.header} must be greater than or equal to ${lower_limit}.`;
                            }
                            if (upperLimit !== null && numericValue > upperLimit) {
                                return `${detail.header} must be less than or equal to ${upper_limit}.`;
                            }
                            return null;
                        };

                        const err = validateNumberField(value);
                        if (err) {
                            errors.push(index);
                            errorMsgs[index] = err;
                        }
                        break;

                    case "date":
                        const d = new Date(value);
                        if (isNaN(d.getTime())) {
                            errors.push(index);
                            errorMsgs[index] = `${detail.header} must be a valid date.`;
                            break;
                        }
                        const inputDateStr = d.toISOString().split("T")[0];
                        const lowerLimitDate = lower_than ? new Date(lower_than) : null;
                        const upperLimitDate = greater_than ? new Date(greater_than) : null;
                        let adjustedLowerLimitDateStr = lowerLimitDate
                            ? lowerLimitDate.toISOString().split("T")[0]
                            : null;
                        let adjustedUpperLimitDateStr = upperLimitDate
                            ? upperLimitDate.toISOString().split("T")[0]
                            : null;
                        if (adjustedLowerLimitDateStr && adjustedUpperLimitDateStr) {
                            if (
                                new Date(adjustedLowerLimitDateStr) >
                                new Date(adjustedUpperLimitDateStr)
                            ) {
                                const temp = adjustedLowerLimitDateStr;
                                adjustedLowerLimitDateStr = adjustedUpperLimitDateStr;
                                adjustedUpperLimitDateStr = temp;
                            }
                        }
                        if (
                            (adjustedLowerLimitDateStr &&
                                inputDateStr < adjustedLowerLimitDateStr) ||
                            (adjustedUpperLimitDateStr &&
                                inputDateStr > adjustedUpperLimitDateStr)
                        ) {
                            errors.push(index);
                            errorMsgs[index] = `${detail.header} must be between ${greater_than} and ${lower_than}.`;
                        }
                        break;

                    case "time":
                        if (value) {
                            let checkTime = moment(value, "HH:mm:ss");
                            let stateTimeN = moment(greater_than, "HH:mm:ss");
                            let endTimeN = moment(lower_than, "HH:mm:ss");
                            if (
                                !(checkTime.isAfter(stateTimeN) && checkTime.isBefore(endTimeN))
                            ) {
                                errors.push(index);
                                errorMsgs[index] = `${detail.header} must be between ${greater_than} and ${lower_than}.`;
                            }
                        }
                        break;

                    case "dropdown":
                        const allowedChoices = Array.isArray(choices)
                            ? choices
                            : typeof choices === "string"
                                ? choices.split(";").map((c) => c.trim())
                                : [];
                        if (allowedChoices.length > 0 && !allowedChoices.includes(value)) {
                            errors.push(index);
                            errorMsgs[index] = `Invalid selection for ${detail.header}. Please select a valid option.`;
                        }
                        break;

                    case "gstin":
                        if (!GSTValidator(value)) {
                            errors.push(index);
                            errorMsgs[index] = `Invalid GSTIN. Must be a 15-character valid GST number (e.g. 22AAAAA0000A1Z5).`;
                        }
                        break;

                    case "pan_number":
                        if (!PANValidator(value)) {
                            errors.push(index);
                            errorMsgs[index] = `Invalid PAN Number.`;
                        }
                        break;

                    case "phone_number":
                        if (!isPhoneNumberValid(value)) {
                            errors.push(index);
                            errorMsgs[index] = `Invalid Phone Number. Must be a valid 10-digit mobile number.`;
                        }
                        break;

                    default:
                        break;
                }

            });


        if (errors.length > 0) {
            setErrorIndexes(errors);
            setErrorMessages(errorMsgs);
            return;
        }

        setErrorIndexes([]);
        setErrorMessages({});

        console.log(`cardDataForSKus >> >> ${JSON.stringify(cardDataForSKus)}`);


        const currentCardData = cardDataForSKus?.results[selectedCard];
        if (!currentCardData) return;

        const updatedSimplifiedInvoiceHeaders = [...(currentCardData.simplifiedinvoiceheaderanswer || [])];
        let hasChanges = false; // Track if any changes were made]
        let newHeaderAnswerAdded = [];




        localInvoiceHeaders.forEach((localHeader) => {

            if (validateInvoiceHeadersAnswer(localHeader.id)) {
                console.log(`validateInvoiceHeadersAnswer >> >> true`);

                updatedSimplifiedInvoiceHeaders.forEach((header) => {
                    const normHeaderType = normalizeHeaderType(header.invoice_header_type);
                    if (normHeaderType === "gstin") {
                        const gstHeader = localInvoiceHeaders.find((lh) => normalizeHeaderType(lh.type || lh.invoiceHeadersTypes) === "gstin" && lh.id === header.invoice_header);
                        const gstHeaderFromUpdateSimplifiedInvoice = updatedSimplifiedInvoiceHeaders.find(
                            (h) => normalizeHeaderType(h.invoice_header_type) === "gstin"
                        );

                        if (gstHeader && gstHeaderFromUpdateSimplifiedInvoice) {
                            const gstNumberDetails = gstHeader?.simplifiedinvoiceheaderanswerdetails?.[0];
                            const gstHeaderDetailsToUpdate = gstHeaderFromUpdateSimplifiedInvoice?.simplifiedinvoiceheaderanswerdetails;

                            if (gstNumberDetails && gstHeaderDetailsToUpdate) {
                                const { gst_legal_name, gst_registration_status, gst_trade_name } = gstNumberDetails;

                                if (gstHeaderDetailsToUpdate.length === 0) {
                                    gstHeaderDetailsToUpdate.push({ gst_legal_name, gst_registration_status, gst_trade_name, is_edit: true });
                                    hasChanges = true;
                                    header.is_edit = true;
                                }
                                else {
                                    Object.assign(gstHeaderDetailsToUpdate[0], { gst_legal_name, gst_registration_status, gst_trade_name, is_edit: true });
                                    hasChanges = true;
                                    header.is_edit = true;
                                }

                            }
                        }
                    }

                    if (header.invoice_header_type === "pan_number") {
                        const gstHeader = localInvoiceHeaders.find((lh) => lh.type === "pan_number" && lh.id === header.invoice_header);
                        const gstHeaderFromUpdateSimplifiedInvoice = updatedSimplifiedInvoiceHeaders.find(
                            (h) => h.invoice_header_type === "pan_number"
                        );

                        if (gstHeader && gstHeaderFromUpdateSimplifiedInvoice) {
                            const gstNumberDetails = gstHeader?.simplifiedinvoiceheaderanswerdetails?.[0];
                            const gstHeaderDetailsToUpdate = gstHeaderFromUpdateSimplifiedInvoice?.simplifiedinvoiceheaderanswerdetails;

                            if (gstNumberDetails && gstHeaderDetailsToUpdate) {
                                const { pan_holder_name } = gstNumberDetails;

                                if (gstHeaderDetailsToUpdate.length === 0) {
                                    gstHeaderDetailsToUpdate.push({ pan_holder_name, is_edit: true });
                                    hasChanges = true;
                                    header.is_edit = true;
                                } else {
                                    Object.assign(gstHeaderDetailsToUpdate[0], { pan_holder_name, is_edit: true });
                                    hasChanges = true;
                                    header.is_edit = true;

                                }

                            }
                        }
                    }
                    // Check and update single_input value if needed
                    if (header.invoice_header === localHeader.id) {
                        let headerVal = localHeader.singleInput?.trim();
                        if (normHeaderType === "phone_number" && headerVal && !headerVal.startsWith("+91") && /^[6-9]\d{9}$/.test(headerVal)) {
                            headerVal = `+91${headerVal}`;
                        }
                        if (header.single_input?.trim() !== headerVal) {
                            header.single_input = headerVal;
                            header.is_edit = true; // Mark the header as edited
                            header.is_qc_edited = true;
                            hasChanges = true; // Flag that there are changes
                        }
                    }
                });
            } else {
                console.log(`validateInvoiceHeadersAnswer >> >> false`);
                if (localHeader.singleInput?.trim()?.length > 0) {
                    let saveInputVal = localHeader.singleInput;
                    const normLocalType = normalizeHeaderType(localHeader.invoiceHeadersTypes || localHeader.type, localHeader.header, localHeader.tag);
                    if (normLocalType === "phone_number" && saveInputVal && !saveInputVal.startsWith("+91") && /^[6-9]\d{9}$/.test(saveInputVal.trim())) {
                        saveInputVal = `+91${saveInputVal.trim()}`;
                    }

                    let newData = {
                        "id": null,
                        "invoice_header": localHeader.id,
                        "invoice_header_type": localHeader.invoiceHeadersTypes,
                        "invoice_header_name": localHeader.header,
                        "is_mandatory": localHeader.is_mandatory,
                        "single_input": saveInputVal,
                        "validations": localHeader.invoiceHeaderValidation || {},
                        "simplifiedinvoiceimageanswer": [],
                        "simplifiedinvoiceheaderanswerdetails": localHeader.simplifiedinvoiceheaderanswerdetails || [],
                        "show_logic_config": localHeader.show_logic_config || {},
                        "is_edit": true,
                        "is_qc_edited": true
                    }

                    updatedSimplifiedInvoiceHeaders.push(newData);
                    hasChanges = true;
                }

            }
        });

        const ocrHeaderAnswers = [];

        localInvoiceHeaders.forEach((item) => {
            const existingAns = findHeaderAnswerInCard(currentCardData?.simplifiedinvoiceheaderanswer, item) ||
                findHeaderAnswerInCard(currentCardData?.invoice_headers, item);

            const ansId = item.answerId || existingAns?.id;
            let newVal = String(item.singleInput ?? "").trim();
            let origVal = String(item.initialSingleInput ?? existingAns?.single_input ?? "").trim();
            const normType = normalizeHeaderType(item.invoiceHeadersTypes || item.type, item.header, item.tag);
            if (normType === "phone_number") {
                if (newVal && !newVal.startsWith("+91") && /^[6-9]\d{9}$/.test(newVal)) {
                    newVal = `+91${newVal}`;
                }
                if (origVal && !origVal.startsWith("+91") && /^[6-9]\d{9}$/.test(origVal)) {
                    origVal = `+91${origVal}`;
                }
            }

            if (ansId) {
                if (newVal !== origVal) {
                    ocrHeaderAnswers.push({
                        id: ansId,
                        single_input: newVal,
                        is_qc_edited: true
                    });
                }
            } else if (newVal !== "") {
                ocrHeaderAnswers.push({
                    invoice_header: item.id,
                    single_input: newVal,
                    is_qc_edited: true
                });
            }
        });

        const ocrHeaderPatch = {};
        if (invoiceNo && invoiceNo !== currentCardData?.invoice_no) {
            ocrHeaderPatch.invoice_no = invoiceNo;
        }
        if (invoiceDate && invoiceDate !== currentCardData?.invoice_date) {
            ocrHeaderPatch.invoice_date = invoiceDate;
        }
        if (ocrHeaderAnswers.length > 0) {
            ocrHeaderPatch.header_answers = ocrHeaderAnswers;
        }

        try {
            if (currentCardData?.id && Object.keys(ocrHeaderPatch).length > 0) {
                await updateOcrInvoice(currentCardData.id, ocrHeaderPatch);
            }

            notificationHandler({
                messageText: `Invoice Header saved successfully.`,
                status: "SUCCESS",
            });
            setRefreshData((prev) => !prev);

        } catch (error) {
            console.error("Error sending payload:", error);
        } finally {
            setEditLoader(false); // Hide loader
        }
    };

    const handleDeleteRow = async () => {
        const currentCardData = cardDataForSKus?.results[selectedCard];
        const targetRow = tableData[selectedRowIndex];

        // Check if row is created locally (has no backend ID or flagged as new)
        const isLocalRow = Boolean(
            isNewSKUDelete ||
            targetRow?.isNew ||
            targetRow?.isNewRow ||
            (!targetRow?.id && !selectedSkuID)
        );

        if (isLocalRow) {
            const updatedTableData = [...tableData];
            updatedTableData.splice(selectedRowIndex, 1);
            setTableData(updatedTableData);
            setSelectedRowIndices([]);
            setIsNewSKUDelete(false);
            return;
        }

        const isAddonRow = Boolean(targetRow?.isAddon || targetRow?.add_on_sku);
        const rawId = selectedSkuID || targetRow?.id || targetRow?.sku;
        const parsedId = rawId !== undefined && rawId !== null ? parseInt(rawId, 10) : null;
        const finalId = isNaN(parsedId) ? rawId : parsedId;

        const deletePayload = isAddonRow
            ? { addon_sku_id: [finalId] }
            : {
                sku_id: [finalId],
                ...(targetRow?.row_index ? { row_index: targetRow.row_index } : {})
            };

        try {
            if (currentCardData?.id && (parsedId || rawId)) {
                await deleteOcrInvoiceSku(currentCardData.id, deletePayload);
                if (props.notificationHandler) {
                    props.notificationHandler({
                        messageText: isAddonRow ? "Add-on SKU deleted successfully." : "SKU deleted successfully.",
                        status: "SUCCESS",
                    });
                }
            }
            const updatedTableData = [...tableData];
            updatedTableData.splice(selectedRowIndex, 1);
            setTableData(updatedTableData);
            setSelectedRowIndices([]);
            if (currentCardData?.id) {
                fetchInvoiceDetail(selectedCard, currentCardData.id);
            }
        } catch (error) {
            console.error("Error deleting row:", error);
            if (props.notificationHandler) {
                props.notificationHandler({
                    messageText: error.message || "Failed to delete SKU.",
                    status: "FAILED",
                });
            }
        }
    };

    const handleDeleteSelectedRows = async () => {
        const currentCardData = cardDataForSKus?.results[selectedCard];
        const indicesToDelete = [...selectedRowIndices].sort((a, b) => b - a);

        if (indicesToDelete.length === 0) return;

        const addonSkuIds = [];
        const regularSkuIds = [];
        const itemsWithRowIndex = [];
        const newTableData = [...tableData];

        for (const index of indicesToDelete) {
            const targetRow = tableData[index];
            const isAddonRow = Boolean(targetRow?.isAddon || targetRow?.add_on_sku);
            const targetSkuID = targetRow?.id || targetRow?.sku || targetRow?.sku_id;
            const isLocalRow = Boolean(
                targetRow?.isNew ||
                targetRow?.isNewRow ||
                !targetSkuID
            );

            if (!isLocalRow && targetSkuID) {
                const parsed = parseInt(targetSkuID, 10);
                const finalId = isNaN(parsed) ? targetSkuID : parsed;
                if (isAddonRow) {
                    addonSkuIds.push(finalId);
                } else if (targetRow?.row_index) {
                    itemsWithRowIndex.push({ sku_id: finalId, row_index: targetRow.row_index });
                } else {
                    regularSkuIds.push(finalId);
                }
            }
        }

        const deletePayload = {};
        if (addonSkuIds.length > 0) {
            deletePayload.addon_sku_id = addonSkuIds;
        }
        if (regularSkuIds.length > 0) {
            deletePayload.sku_id = regularSkuIds;
        }
        if (itemsWithRowIndex.length > 0) {
            deletePayload.items = itemsWithRowIndex;
        }

        try {
            if (currentCardData?.id && Object.keys(deletePayload).length > 0) {
                await deleteOcrInvoiceSku(currentCardData.id, deletePayload);
                if (props.notificationHandler) {
                    const totalCount =
                        addonSkuIds.length + regularSkuIds.length + itemsWithRowIndex.length || indicesToDelete.length;
                    props.notificationHandler({
                        messageText: `${totalCount} SKU(s) deleted successfully.`,
                        status: "SUCCESS",
                    });
                }
            }

            for (const index of indicesToDelete) {
                newTableData.splice(index, 1);
            }

            setTableData(newTableData);
            setSelectedRowIndices([]);
            if (currentCardData?.id) {
                fetchInvoiceDetail(selectedCard, currentCardData.id);
            }
        } catch (err) {
            console.error("Error deleting selected rows:", err);
            if (props.notificationHandler) {
                props.notificationHandler({
                    messageText: err.message || "Failed to delete selected SKUs.",
                    status: "FAILED",
                });
            }
        }
    };

    const handleSelectAllRows = (e) => {
        if (e.target.checked) {
            setSelectedRowIndices(tableData.map((_, index) => index));
        } else {
            setSelectedRowIndices([]);
        }
    };

    const handleToggleRowSelect = (rowIndex) => {
        setSelectedRowIndices((prev) =>
            prev.includes(rowIndex)
                ? prev.filter((i) => i !== rowIndex)
                : [...prev, rowIndex]
        );
    };

    const simplifiedInvoiceSkuData =
        cardDataForSKus?.results[selectedCard]?.simplifiedinvoiceskudata || [];

    const [selectedSkuIds, setSelectedSkuIds] = useState([]);

    const handleCheckboxChange = (id, isChecked) => {
        setSelectedSkuIds((prevSelectedIds) =>
            isChecked
                ? [...prevSelectedIds, id]
                : prevSelectedIds.filter((skuId) => skuId !== id)
        );
    };

    const handleExportToExcelButtonClick = (id) => {
        const payload = {
            data_to_export: [
                {
                    id: selectedSkuIds,
                },
            ],
            workflow_object_id: props.outletDetails.workflow_object,
            add_on_sku: "Test",
        };

        createaddskuexcel(id, payload)
            .then((response) => {
                const filePath = response.file_path.replace(
                    "/app/retailscan_backend/",
                    `${AppConfig.api_url}`
                );
                window.open(filePath, "_blank");
            })
            .catch((error) => {
                console.error("API Error:", error);
            });
    };


    const renderTable = (
        <div className="id-card" style={{ marginTop: "16px" }}>
            <div className="sku-card-top-bar">
                <h3 className="id-card-title">SKU Line Items</h3>

                {enableEditAnswers ? (
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <button
                            className="sku-add-another-link"
                            onClick={handleOpenAddSkuModal}
                        >
                            <Add style={{ fontSize: "16px" }} />
                            <span>Add Another SKU</span>
                        </button>
                        <button
                            className="sku-add-another-link"
                            disabled={selectedRowIndices.length === 0 || isDeleting}
                            onClick={handleOpenBulkDeleteDialog}
                            style={{
                                opacity: selectedRowIndices.length > 0 && !isDeleting ? 1 : 0.5,
                                cursor: selectedRowIndices.length > 0 && !isDeleting ? "pointer" : "not-allowed",
                                color: selectedRowIndices.length > 0 && !isDeleting ? "#ef4444" : "#94a3b8",
                                borderColor: selectedRowIndices.length > 0 && !isDeleting ? "#ef4444" : "#cbd5e1",
                                display: "flex",
                                alignItems: "center",
                                gap: "4px"
                            }}
                        >
                            <DeleteIcon style={{ fontSize: "16px" }} />
                            <span>Delete ({selectedRowIndices.length})</span>
                        </button>
                    </div>
                ) : null}
            </div>

            {tableData.length === 0 ? (
                <div style={{ textAlign: "center", padding: "30px", color: "#94a3b8" }}>
                    No SKU entries found for this invoice.
                </div>
            ) : (
                <div className="sku-table-outer">
                    <table {...getTableProps()} className="sku-modern-table">
                        <thead>
                            {headerGroups.map((headerGroup, headerGroupIndex) => (
                                <tr
                                    {...headerGroup.getHeaderGroupProps()}
                                    key={`headerGroup-${headerGroupIndex}`}
                                >
                                    {enableEditAnswers && (
                                        <th style={{ width: "40px", textAlign: "center" }}>
                                            <input
                                                type="checkbox"
                                                checked={tableData.length > 0 && selectedRowIndices.length === tableData.length}
                                                onChange={handleSelectAllRows}
                                                style={{ cursor: "pointer", width: "16px", height: "16px" }}
                                            />
                                        </th>
                                    )}
                                    {headerGroup.headers.map((column, columnIndex) => {
                                        const isFrozen = column.id === "sku_name";
                                        return (
                                            <th
                                                {...column.getHeaderProps()}
                                                key={`column-${columnIndex}`}
                                                className={isFrozen ? "sku-col-frozen" : ""}
                                                style={{
                                                    textAlign: isFrozen ? "left" : "center",
                                                    minWidth: isFrozen ? "220px" : "110px",
                                                }}
                                            >
                                                {column.render("Header")}
                                                {column.is_mandatory && (
                                                    <span style={{ color: "#ef4444", marginLeft: "2px" }}>*</span>
                                                )}
                                            </th>
                                        );
                                    })}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {rows.map((row, rowIndex) => {
                                prepareRow(row);
                                const isRowSelected = selectedRowIndices.includes(rowIndex);
                                return (
                                    <tr
                                        {...row.getRowProps()}
                                        key={`row-${rowIndex}-${row.original?.sku || row.original?.id || ''}-${row.original?.row_index || ''}`}
                                        style={{ backgroundColor: isRowSelected ? "#f1f5f9" : "transparent" }}
                                    >
                                        {enableEditAnswers && (
                                            <td style={{ textAlign: "center", width: "40px", paddingTop: "18px" }}>
                                                <input
                                                    type="checkbox"
                                                    checked={isRowSelected}
                                                    onChange={() => handleToggleRowSelect(rowIndex)}
                                                    style={{ cursor: "pointer", width: "16px", height: "16px" }}
                                                />
                                            </td>
                                        )}
                                        {/* SKU Name Column */}
                                        {row.cells
                                            .filter(
                                                (cell) =>
                                                    cell.column.id === "sku_name" ||
                                                    cell.column.id === "add_on_sku"
                                            )
                                            .map((cell, cellIndex) => {
                                                const isFrozen = cell.column.id === "sku_name";
                                                return (
                                                    <td
                                                        {...cell.getCellProps()}
                                                        key={`cell-${rowIndex}-${cellIndex}`}
                                                        className={isFrozen ? "sku-col-frozen" : ""}
                                                    >
                                                        {cell.column.id === "sku_name" ? (
                                                            <div>
                                                                {(() => {
                                                                    const isSkuEdited = isFieldEdited(tableData[rowIndex]) || isFieldEdited(tableData[rowIndex]?.[cell.column.id]);
                                                                    return (
                                                                        <div
                                                                            className={`sku-dropdown-trigger ${!enableEditAnswers ? "disabled" : ""} ${isSkuEdited ? "is-edited-orange" : ""}`}
                                                                            style={!enableEditAnswers ? { pointerEvents: "none", backgroundColor: isSkuEdited ? "#fff7ed" : "#f8fafc", cursor: "not-allowed", color: "#64748b" } : {}}
                                                                            title={isSkuEdited ? "Edited (MT/QC)" : undefined}
                                                                            onClick={() => {
                                                                                if (!enableEditAnswers) return;
                                                                                setModalErrorMessage("");
                                                                                setTestCallIndex(cell);
                                                                                setTestRowIndex(rowIndex);
                                                                                setSkuPage(1);
                                                                                setFirstModalActive(true);
                                                                            }}
                                                                        >
                                                                            <span className="sku-dropdown-text">
                                                                                {tableData[rowIndex]?.sku_name || tableData[rowIndex]?.[cell.column.id] || "Select SKU"}
                                                                            </span>
                                                                            {enableEditAnswers && <ExpandMoreIcon style={{ fontSize: "18px", color: "#64748b" }} />}
                                                                        </div>
                                                                    );
                                                                })()}
                                                                {tableData[rowIndex]?.add_on_sku && (
                                                                    <div
                                                                        style={{
                                                                            fontSize: "11px",
                                                                            color: "#ef4444",
                                                                            fontWeight: "600",
                                                                            marginTop: "4px",
                                                                        }}
                                                                    >
                                                                        Add-on: {tableData[rowIndex].add_on_sku}
                                                                    </div>
                                                                )}
                                                                {validationErrors.some(
                                                                    (error) =>
                                                                        error.rowIndex === rowIndex &&
                                                                        error.columnId === "sku_name"
                                                                ) && (
                                                                        <div
                                                                            style={{
                                                                                color: "#ef4444",
                                                                                fontSize: "11px",
                                                                                marginTop: "2px",
                                                                            }}
                                                                        >
                                                                            {validationErrors.find(
                                                                                (error) =>
                                                                                    error.rowIndex === rowIndex &&
                                                                                    error.columnId === "sku_name"
                                                                            )?.message}
                                                                        </div>
                                                                    )}
                                                            </div>
                                                        ) : (
                                                            <div>
                                                                {tableData[rowIndex]?.add_on_sku || "No Add-on SKU"}
                                                            </div>
                                                        )}
                                                    </td>
                                                );
                                            })}

                                        {/* Other Data Columns */}
                                        {row.cells
                                            .filter((cell) => cell.column.id !== "sku_name" && cell.column.id !== "add_on_sku")
                                            .map((cell, cellIndex) => {
                                                const hasError = validationErrors.some(
                                                    (error) =>
                                                        error.rowIndex === rowIndex &&
                                                        error.columnId === cell.column.id
                                                );

                                                const cellObj = tableData[rowIndex]?.[cell.column.id];
                                                const isCellEdited = isFieldEdited(cellObj) || isFieldEdited(cell.value);
                                                const cropImg = cell.value?.image_answer || cellObj?.image_answer || null;
                                                const rawCellType = cell.value?.type || cell.column?.type;
                                                const cellHeaderName = cell.value?.headerName || cell.column?.Header || "";
                                                const cellNormType = normalizeTemplateType(rawCellType, cellHeaderName);
                                                const isCellQty = cellNormType === "integer";
                                                const isCellDecimal = cellNormType === "decimal";

                                                const isAutoSkuCol = isAutoPopulatedDisabledSkuField(cell.column) || isAutoPopulatedDisabledSkuField(cell.value) || isAutoPopulatedDisabledSkuField(cellObj);
                                                const isPackshotCol = isPackshotImageField(cell.column) || isPackshotImageField(cell.value) || isPackshotImageField(cellObj) || cellNormType === "image";
                                                const hasPackshotImg = Boolean(
                                                    cropImg ||
                                                    cellObj?.has_image_answer ||
                                                    cell.value?.has_image_answer ||
                                                    (Array.isArray(cellObj?.simplifiedinvoiceskuimageanswer) && cellObj.simplifiedinvoiceskuimageanswer.length > 0) ||
                                                    (Array.isArray(cell.value?.simplifiedinvoiceskuimageanswer) && cell.value.simplifiedinvoiceskuimageanswer.length > 0)
                                                );

                                                const cellRawVal = tableData[rowIndex]?.[cell.column.id]?.value !== undefined
                                                    ? tableData[rowIndex][cell.column.id].value
                                                    : tableData[rowIndex]?.[cell.column.id];

                                                let cellDisplayVal = "";
                                                if (isPackshotCol) {
                                                    cellDisplayVal = hasPackshotImg ? "Image Answered" : "";
                                                } else if (cellRawVal !== undefined && cellRawVal !== null && String(cellRawVal).trim() !== "") {
                                                    cellDisplayVal = cellRawVal;
                                                } else if (isAutoSkuCol) {
                                                    cellDisplayVal = tableData[rowIndex]?.sku_name || "";
                                                }

                                                return (
                                                    <td
                                                        {...cell.getCellProps()}
                                                        key={`cell-${rowIndex}-${cellIndex}`}
                                                    >
                                                        <div style={{ display: "flex", alignItems: "center" }}>
                                                            {cellNormType === "dropdown" ? (
                                                                <select
                                                                    className={`sku-row-select ${hasError ? "has-error" : ""} ${isCellEdited ? "is-edited-orange" : ""}`}
                                                                    title={isCellEdited ? "Edited (MT/QC)" : undefined}
                                                                    disabled={!enableEditAnswers || isDisabledSkuField(cell.column) || isDisabledSkuField(cellObj)}
                                                                    style={(isDisabledSkuField(cell.column) || isDisabledSkuField(cellObj)) ? { backgroundColor: "#f8fafc", cursor: "not-allowed", color: "#64748b" } : undefined}
                                                                    value={
                                                                        tableData[rowIndex]?.[cell.column.id]?.value !== undefined
                                                                            ? tableData[rowIndex][cell.column.id].value
                                                                            : (tableData[rowIndex]?.[cell.column.id] || "")
                                                                    }
                                                                    onChange={(event) => {
                                                                        const value = event.target.value === "" ? null : event.target.value;
                                                                        handleInputChange(
                                                                            event,
                                                                            rowIndex,
                                                                            cell.column.id,
                                                                            value,
                                                                            "dropdown",
                                                                            value === null
                                                                        );
                                                                    }}
                                                                >
                                                                    <option value="">Select</option>
                                                                    {cell.value?.validations?.choices &&
                                                                        cell.value.validations.choices
                                                                            .split(";")
                                                                            .map((choice, index) => (
                                                                                <option
                                                                                    key={index}
                                                                                    value={choice.trim()}
                                                                                >
                                                                                    {choice.trim()}
                                                                                </option>
                                                                            ))}
                                                                </select>
                                                            ) : (
                                                                <input
                                                                    inputMode={isCellQty ? "numeric" : isCellDecimal ? "decimal" : undefined}
                                                                    type={cellNormType === "date" ? "date" : cellNormType === "time" ? "time" : "text"}
                                                                    step={isCellQty ? "1" : isCellDecimal ? "any" : undefined}
                                                                    disabled={!enableEditAnswers || isDisabledSkuField(cell.column) || isDisabledSkuField(cellObj)}
                                                                    style={(isDisabledSkuField(cell.column) || isDisabledSkuField(cellObj))
                                                                        ? {
                                                                            backgroundColor: "#f8fafc",
                                                                            cursor: "not-allowed",
                                                                            color: isPackshotCol && hasPackshotImg ? "#2563eb" : "#64748b",
                                                                            fontWeight: isPackshotCol && hasPackshotImg ? 600 : undefined
                                                                        }
                                                                        : undefined}
                                                                    className={`sku-row-input ${hasError ? "has-error" : ""} ${isCellEdited ? "is-edited-orange" : ""}`}
                                                                    title={isCellEdited ? "Edited (MT/QC)" : undefined}
                                                                    placeholder={(isDisabledSkuField(cell.column) || isDisabledSkuField(cellObj)) ? "" : (isCellQty ? "Enter Qty" : isCellDecimal ? "Enter Val" : "Enter...")}
                                                                    onWheel={(e) => e.target.blur()}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === "Enter") {
                                                                            e.preventDefault();
                                                                            const inputs = Array.from(
                                                                                document.querySelectorAll('.sku-modern-table input:not([type="hidden"]):not([disabled]), .sku-modern-table select:not([disabled])')
                                                                            );
                                                                            const idx = inputs.indexOf(e.target);
                                                                            if (idx > -1 && idx < inputs.length - 1) {
                                                                                inputs[idx + 1].focus();
                                                                                if (inputs[idx + 1].select) {
                                                                                    inputs[idx + 1].select();
                                                                                }
                                                                            }
                                                                        }
                                                                    }}
                                                                    value={cellDisplayVal}
                                                                    onChange={(e) => {
                                                                        const val = e.target.value;
                                                                        if (isCellQty) {
                                                                            const cleaned = val.replace(/[^0-9]/g, "");
                                                                            handleInputChange(e, rowIndex, cell.column.id, cleaned, "integer");
                                                                        } else if (isCellDecimal) {
                                                                            let cleaned = val.replace(/[^0-9.]/g, "");
                                                                            const parts = cleaned.split(".");
                                                                            if (parts.length > 2) {
                                                                                cleaned = parts[0] + "." + parts.slice(1).join("");
                                                                            }
                                                                            handleInputChange(e, rowIndex, cell.column.id, cleaned, "decimal");
                                                                        } else {
                                                                            handleInputChange(e, rowIndex, cell.column.id, val, cellNormType);
                                                                        }
                                                                    }}
                                                                />
                                                            )}
                                                            {!isPackshotCol && cropImg && (
                                                                <IconButton
                                                                    size="small"
                                                                    style={{ padding: "2px", marginLeft: "4px", color: "#318CE7" }}
                                                                    title="View OCR Crop Image Source"
                                                                    onClick={() => setCropImageModalUrl(cropImg)}
                                                                >
                                                                    <ImageIcon style={{ fontSize: "16px" }} />
                                                                </IconButton>
                                                            )}
                                                        </div>

                                                        {hasError && (
                                                            <div style={{ color: "#ef4444", fontSize: "10px", marginTop: "2px" }}>
                                                                {validationErrors.find(
                                                                    (error) =>
                                                                        error.rowIndex === rowIndex &&
                                                                        error.columnId === cell.column.id
                                                                )?.message}
                                                            </div>
                                                        )}
                                                    </td>
                                                );
                                            })}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}



            {/* Modern Confirm Deletion Dialog */}
            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                PaperProps={{
                    style: {
                        borderRadius: "16px",
                        padding: "0px",
                        maxWidth: "440px",
                        width: "100%",
                        boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
                        overflow: "hidden"
                    }
                }}
            >
                <div style={{ padding: "24px", fontFamily: "Barlow, sans-serif" }}>
                    <div style={{ display: "flex", alignItems: "flex-start", gap: "16px" }}>
                        <div style={{
                            width: "44px",
                            height: "44px",
                            borderRadius: "12px",
                            background: "#fef2f2",
                            color: "#ef4444",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0
                        }}>
                            <DeleteIcon style={{ fontSize: "24px" }} />
                        </div>
                        <div style={{ flex: 1 }}>
                            <h3 style={{ margin: "0 0 6px 0", fontSize: "18px", fontWeight: 700, color: "#0f172a" }}>
                                {isBulkDelete ? "Confirm Bulk Deletion" : "Delete SKU Line Item"}
                            </h3>
                            <p style={{ margin: 0, fontSize: "14px", color: "#64748b", lineHeight: 1.5 }}>
                                {isBulkDelete
                                    ? `Are you sure you want to delete ${selectedRowIndices.length} selected row(s)? This action cannot be undone.`
                                    : "Are you sure you want to delete this row? This action cannot be undone."}
                            </p>
                        </div>
                    </div>
                </div>

                <div style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: "10px",
                    padding: "16px 24px",
                    background: "#fafafa",
                    borderTop: "1px solid #f1f5f9"
                }}>
                    <button
                        onClick={handleCloseDialog}
                        disabled={isDeleting}
                        style={{
                            padding: "9px 20px",
                            fontSize: "13px",
                            fontWeight: 600,
                            borderRadius: "8px",
                            border: "1px solid #cbd5e1",
                            background: "#ffffff",
                            color: isDeleting ? "#94a3b8" : "#475569",
                            cursor: isDeleting ? "not-allowed" : "pointer",
                            transition: "all 0.15s ease",
                            fontFamily: "Barlow, sans-serif"
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={confirmDelete}
                        disabled={isDeleting}
                        style={{
                            padding: "9px 22px",
                            fontSize: "13px",
                            fontWeight: 600,
                            borderRadius: "8px",
                            border: "none",
                            background: isDeleting ? "#fca5a5" : "#ef4444",
                            color: "#ffffff",
                            cursor: isDeleting ? "not-allowed" : "pointer",
                            boxShadow: "0 2px 4px rgba(239, 68, 68, 0.25)",
                            transition: "all 0.15s ease",
                            fontFamily: "Barlow, sans-serif"
                        }}
                    >
                        {isDeleting ? "Deleting..." : "Delete"}
                    </button>
                </div>
            </Dialog>

            {/* Add New SKU Dialog */}
            <Dialog
                open={openAddSkuModal}
                onClose={handleCloseAddSkuModal}
                maxWidth="sm"
                fullWidth={true}
                PaperProps={{
                    style: {
                        borderRadius: "16px",
                        padding: "0",
                        boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
                        overflow: "visible"
                    }
                }}
            >
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "18px 24px",
                    borderBottom: "1px solid #f1f5f9",
                    background: "#ffffff"
                }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <div style={{
                            width: "38px",
                            height: "38px",
                            borderRadius: "10px",
                            background: "#eff6ff",
                            color: "#2563eb",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}>
                            <Add style={{ fontSize: "22px" }} />
                        </div>
                        <div>
                            <h3 style={{ margin: 0, fontSize: "17px", fontWeight: 700, color: "#0f172a", fontFamily: "Barlow, sans-serif" }}>
                                Add New SKU
                            </h3>
                            <span style={{ fontSize: "12px", color: "#64748b", fontFamily: "Barlow, sans-serif" }}>
                                Search and select a SKU from catalog and enter details
                            </span>
                        </div>
                    </div>
                    <button
                        onClick={handleCloseAddSkuModal}
                        style={{
                            background: "#f8fafc",
                            border: "none",
                            borderRadius: "50%",
                            width: "32px",
                            height: "32px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#64748b",
                            transition: "all 0.15s ease"
                        }}
                    >
                        <CloseIcon style={{ fontSize: "18px" }} />
                    </button>
                </div>

                <div style={{ padding: "20px 24px 10px 24px", maxHeight: "60vh", overflowY: "auto", fontFamily: "Barlow, sans-serif" }}>
                    <div style={{ marginBottom: "18px" }}>
                        <label style={{ display: "block", fontSize: "13px", fontWeight: 600, color: "#334155", marginBottom: "6px" }}>
                            SKU Name <span style={{ color: "#ef4444" }}>*</span>
                        </label>
                        <SelectFilter
                            width="100%"
                            height="42px"
                            borderRadius="8px"
                            customStyles={{
                                borderColor: addSkuModalErrors.sku_name ? "#ef4444" : undefined,
                                boxShadow: addSkuModalErrors.sku_name ? "0 0 0 1px #ef4444" : undefined,
                            }}
                            props={{
                                options: skuSelectOptions,
                                name: "sku_name",
                                placeholder: "Search or Select SKU Name...",
                                isLoading: loadingSku && skuPage === 1,
                                components: selectComponents,
                                onMenuScrollToBottom: () => {
                                    if (!loadingSku && skuPage < skuTotalPages) {
                                        setSkuPage((prev) => prev + 1);
                                    }
                                },
                                onInputChange: (inputValue, { action }) => {
                                    if (action === "input-change") {
                                        setAddSkuSearchInput(inputValue);
                                    }
                                },
                                filterOption: (option, rawInput) => {
                                    if (!rawInput) return true;
                                    const search = rawInput.toLowerCase().trim();
                                    const label = (option.label || "").toLowerCase();
                                    const sku = String(option.sku || "").toLowerCase();
                                    const skuName = (option.sku_name || "").toLowerCase();
                                    return label.includes(search) || sku.includes(search) || skuName.includes(search);
                                },
                                value: skuSelectOptions.find(
                                    (opt) => (newSkuFormData.sku && String(opt.sku) === String(newSkuFormData.sku)) || opt.sku_name === newSkuFormData.sku_name
                                ) || (newSkuFormData.sku_name ? {
                                    label: `${newSkuFormData.sku_name} ${newSkuFormData.sku ? `(#${newSkuFormData.sku})` : ""}`,
                                    value: newSkuFormData.sku ? String(newSkuFormData.sku) : newSkuFormData.sku_name,
                                    sku_name: newSkuFormData.sku_name,
                                    sku: newSkuFormData.sku,
                                } : null),
                                onChange: (selectedOpt) => {
                                    if (selectedOpt) {
                                        if (addSkuModalErrors.sku_name) {
                                            setAddSkuModalErrors((prev) => {
                                                const updated = { ...prev };
                                                delete updated.sku_name;
                                                return updated;
                                            });
                                        }

                                        const chosenSku = selectedOpt.sku_name || selectedOpt.label;
                                        setNewSkuFormData((prev) => {
                                            const nextData = {
                                                ...prev,
                                                sku_name: chosenSku,
                                                sku: selectedOpt.sku || null,
                                            };
                                            columns.forEach((col) => {
                                                if (isAutoPopulatedDisabledSkuField(col)) {
                                                    nextData[col.accessor] = chosenSku;
                                                }
                                            });
                                            return nextData;
                                        });
                                    } else {
                                        setNewSkuFormData((prev) => {
                                            const nextData = {
                                                ...prev,
                                                sku_name: "",
                                                sku: null,
                                            };
                                            columns.forEach((col) => {
                                                if (isAutoPopulatedDisabledSkuField(col)) {
                                                    nextData[col.accessor] = "";
                                                }
                                            });
                                            return nextData;
                                        });
                                    }
                                },
                                isClearable: true,
                                isSearchable: true,
                            }}
                            warnMessage={{
                                text: addSkuModalErrors.sku_name,
                                align: "left"
                            }}
                            noOptionMessage="No matching SKU found"
                        />
                    </div>

                    {columns
                        .filter((col) => col.accessor !== "sku_name")
                        .map((col) => {
                            const hasErr = addSkuModalErrors[col.accessor];
                            const modalColType = normalizeTemplateType(col.type, col.Header);
                            const modalIsQty = modalColType === "integer";
                            const modalIsDecimal = modalColType === "decimal";
                            const isColAutoSku = isAutoPopulatedDisabledSkuField(col);
                            const isColDisabled = isDisabledSkuField(col);

                            return (
                                <div key={col.accessor} style={{ marginBottom: "16px" }}>
                                    <label style={{ display: "block", fontSize: "13px", fontWeight: 600, color: "#334155", marginBottom: "6px" }}>
                                        {col.Header}
                                        {col.is_mandatory && <span style={{ color: "#ef4444", marginLeft: "4px" }}>*</span>}
                                    </label>
                                    {modalColType === "dropdown" ? (
                                        <select
                                            disabled={isColDisabled}
                                            value={newSkuFormData[col.accessor] || ""}
                                            onChange={(e) => handleAddSkuInputChange(col.accessor, e.target.value)}
                                            style={{
                                                width: "100%",
                                                padding: "10px 14px",
                                                fontSize: "14px",
                                                borderRadius: "8px",
                                                border: hasErr ? "1.5px solid #ef4444" : "1px solid #cbd5e1",
                                                outline: "none",
                                                boxSizing: "border-box",
                                                color: isColDisabled ? "#64748b" : "#1e293b",
                                                fontFamily: "Barlow, sans-serif",
                                                background: isColDisabled ? "#f8fafc" : "#ffffff",
                                                cursor: isColDisabled ? "not-allowed" : "pointer"
                                            }}
                                        >
                                            <option value="">Select</option>
                                            {col.validations?.choices &&
                                                col.validations.choices.split(";").map((choice, i) => (
                                                    <option key={i} value={choice.trim()}>
                                                        {choice.trim()}
                                                    </option>
                                                ))}
                                        </select>
                                    ) : (
                                        <input
                                            type={modalColType === "date" ? "date" : modalColType === "time" ? "time" : "text"}
                                            step={modalIsQty ? "1" : modalIsDecimal ? "any" : undefined}
                                            inputMode={modalIsQty ? "numeric" : modalIsDecimal ? "decimal" : undefined}
                                            disabled={isColDisabled}
                                            onWheel={(e) => e.target.blur()}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    e.preventDefault();
                                                    const container = e.target.closest('[role="dialog"]') || e.target.closest('.MuiDialog-root') || document;
                                                    const inputs = Array.from(container.querySelectorAll('input:not([type="hidden"]):not([disabled]), select:not([disabled]), button:not([disabled])'));
                                                    const idx = inputs.indexOf(e.target);
                                                    if (idx > -1 && idx < inputs.length - 1) {
                                                        inputs[idx + 1].focus();
                                                        if (inputs[idx + 1].select) {
                                                            inputs[idx + 1].select();
                                                        }
                                                    }
                                                }
                                            }}
                                            value={
                                                isColAutoSku
                                                    ? (newSkuFormData[col.accessor] || newSkuFormData.sku_name || "")
                                                    : (newSkuFormData[col.accessor] || "")
                                            }
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                if (modalIsQty) {
                                                    if (/^\d*$/.test(val)) {
                                                        handleAddSkuInputChange(col.accessor, val);
                                                    }
                                                } else if (modalIsDecimal) {
                                                    if (/^\d*\.?\d*$/.test(val) || val === "") {
                                                        handleAddSkuInputChange(col.accessor, val);
                                                    }
                                                } else {
                                                    handleAddSkuInputChange(col.accessor, val);
                                                }
                                            }}
                                            placeholder={isColDisabled ? "" : (modalIsQty ? "Enter Qty" : modalIsDecimal ? "Enter Val" : `Enter ${col.Header}`)}
                                            style={{
                                                width: "100%",
                                                padding: "10px 14px",
                                                fontSize: "14px",
                                                borderRadius: "8px",
                                                border: hasErr ? "1.5px solid #ef4444" : "1px solid #cbd5e1",
                                                outline: "none",
                                                boxSizing: "border-box",
                                                color: isColDisabled ? "#64748b" : "#1e293b",
                                                fontFamily: "Barlow, sans-serif",
                                                background: isColDisabled ? "#f8fafc" : "#ffffff",
                                                cursor: isColDisabled ? "not-allowed" : "text"
                                            }}
                                        />
                                    )}
                                    {hasErr && (
                                        <span style={{ color: "#ef4444", fontSize: "11px", marginTop: "4px", display: "block" }}>
                                            {hasErr}
                                        </span>
                                    )}
                                </div>
                            );
                        })}
                </div>

                <div style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: "10px",
                    padding: "16px 24px",
                    borderTop: "1px solid #f1f5f9",
                    background: "#fafafa"
                }}>
                    <button
                        onClick={handleCloseAddSkuModal}
                        style={{
                            padding: "9px 20px",
                            fontSize: "13px",
                            fontWeight: 600,
                            borderRadius: "8px",
                            border: "1px solid #cbd5e1",
                            background: "#ffffff",
                            color: "#475569",
                            cursor: "pointer",
                            fontFamily: "Barlow, sans-serif"
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSaveAddSku}
                        style={{
                            padding: "9px 24px",
                            fontSize: "13px",
                            fontWeight: 600,
                            borderRadius: "8px",
                            border: "none",
                            background: "#2563eb",
                            color: "#ffffff",
                            cursor: "pointer",
                            boxShadow: "0 2px 4px rgba(37, 99, 235, 0.25)",
                            fontFamily: "Barlow, sans-serif"
                        }}
                    >
                        Save SKU
                    </button>
                </div>
            </Dialog>
        </div>
    );

    const hasValidInvoice = Boolean(
        cardDataForSKus?.results &&
        cardDataForSKus.results.length > 0 &&
        cardDataForSKus.results[0]?.id
    );

    return (
        <React.Fragment>
            {loading ? (
                <div style={{ textAlign: "center", padding: "50px" }}>
                    <CircularProgress size={80} style={{ color: "#318CE7" }} />
                </div>
            ) : !hasValidInvoice ? (
                <div className="invoice-digi-wrapper">
                    <div className="id-card">
                        <div className="id-card-header">
                            <h3 className="id-card-title">Invoice Details</h3>
                        </div>
                        <div style={{ padding: "40px 20px", textAlign: "center", color: "#94a3b8", fontSize: "14px", fontFamily: "Barlow, sans-serif" }}>
                            No invoice details found.
                        </div>
                    </div>

                    <div className="id-card" style={{ marginTop: "16px" }}>
                        <div className="sku-card-top-bar">
                            <h3 className="id-card-title">SKU Line Items</h3>
                        </div>
                        <div style={{ padding: "40px 20px", textAlign: "center", color: "#94a3b8", fontSize: "14px", fontFamily: "Barlow, sans-serif" }}>
                            No SKU entries found for this invoice.
                        </div>
                    </div>

                    {enableEditAnswers && (
                        <div className="id-screen-footer" style={{ marginTop: "24px" }}>
                            <div className="id-footer-btns-group">
                                <button
                                    title={`Submit (${getShortcutLabel("SAVE")})`}
                                    className="id-btn-submit-empanelment"
                                    onClick={handleSaveNext}
                                    disabled={loading || editLoader}
                                >
                                    {editLoader ? "Please Wait.." : "Submit"}
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            ) : (
                <div className="invoice-digi-wrapper">
                    {/* Top Carousel Navigation */}
                    <div className="bill-nav-container">
                        <button
                            type="button"
                            className="bill-nav-arrow-btn"
                            onClick={handlePrevCard}
                            title="Previous Bill"
                        >
                            <ChevronLeftRounded />
                        </button>

                        <div className="bill-pills-scroll" ref={cardContainerRef}>
                            {cardDataForSKus?.results?.map((card, index) => {
                                const isSaved = Boolean(
                                    savedCards[index] ||
                                    (card?.id && savedCards[`id_${card.id}`])
                                );
                                const isActive = selectedCard === index;

                                return (
                                    <div
                                        key={index}
                                        className={`bill-pill ${isActive ? "active" : ""} ${isSaved ? "saved" : ""}`}
                                        onClick={() => {
                                            setSelectedCard(index);
                                            setSelectedRowIndices([]);
                                            setErrorIndexes([]);
                                            setErrorMessages({});
                                            fetchInvoiceDetail(index);
                                        }}
                                    >
                                        <span className="bill-pill-status-dot" />
                                        <span>{cardTexts[index] || `Bill ${index + 1}`}</span>

                                        {enableEditAnswers && isActive && (
                                            <EditIcon
                                                style={{ fontSize: "15px", color: "#ffffff", marginLeft: "4px", cursor: "pointer" }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleEditClick(index);
                                                }}
                                            />
                                        )}
                                    </div>
                                );
                            })}
                        </div>

                        <button
                            type="button"
                            className="bill-nav-arrow-btn"
                            onClick={handleNextCard}
                            title="Next Bill"
                        >
                            <ChevronRightIcon />
                        </button>
                    </div>

                    {/* Edit Invoice Header Dialog */}
                    <Dialog
                        open={open}
                        onClose={handleClose}
                        PaperProps={{
                            style: {
                                borderRadius: "16px",
                                padding: "0",
                                maxWidth: "460px",
                                width: "100%",
                                boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
                                overflow: "hidden"
                            }
                        }}
                    >
                        {/* Custom Modal Header */}
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "18px 24px",
                            borderBottom: "1px solid #f1f5f9",
                            background: "#ffffff"
                        }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                <div style={{
                                    width: "38px",
                                    height: "38px",
                                    borderRadius: "10px",
                                    background: "#eff6ff",
                                    color: "#2563eb",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}>
                                    <EditIcon style={{ fontSize: "20px" }} />
                                </div>
                                <div>
                                    <h3 style={{ margin: 0, fontSize: "17px", fontWeight: 700, color: "#0f172a", fontFamily: "Barlow, sans-serif" }}>
                                        Edit Invoice Header
                                    </h3>
                                    <span style={{ fontSize: "12px", color: "#64748b", fontFamily: "Barlow, sans-serif" }}>
                                        Update invoice number & date
                                    </span>
                                </div>
                            </div>
                            <button
                                onClick={handleClose}
                                style={{
                                    background: "#f8fafc",
                                    border: "none",
                                    borderRadius: "50%",
                                    width: "32px",
                                    height: "32px",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#64748b",
                                    transition: "all 0.15s ease"
                                }}
                            >
                                <CloseIcon style={{ fontSize: "18px" }} />
                            </button>
                        </div>

                        {/* Custom Modal Body */}
                        <div style={{ padding: "20px 24px 10px 24px", fontFamily: "Barlow, sans-serif" }}>
                            {(() => {
                                const currentCardForModal = cardDataForSKus?.results?.[selectedCard];
                                const invNoHdr = (
                                    (currentCardForModal?.invoice_headers || []).find((h) => h.tag === "invoice_number" || (h.name && h.name.toLowerCase().trim() === "invoice number")) ||
                                    (currentCardForModal?.assign_simplifiedinvoiceheader_field || []).find((h) => h.tag === "invoice_number" || (h.name && h.name.toLowerCase().trim() === "invoice number")) ||
                                    (localInvoiceHeaders || []).find((h) => h.tag === "invoice_number" || (h.header && h.header.toLowerCase().trim() === "invoice number"))
                                );
                                const isInvNoMandatory = invNoHdr?.is_mandatory !== undefined ? Boolean(invNoHdr.is_mandatory) : true;
                                const invNoAns = Array.isArray(invNoHdr?.invoice_header_answer) ? invNoHdr.invoice_header_answer[0] : null;
                                const isInvNoEdited = Boolean(isFieldEdited(invNoAns) || isFieldEdited(invNoHdr) || isFieldEdited(currentCardForModal));

                                const invDateHdr = (
                                    (currentCardForModal?.invoice_headers || []).find((h) => h.tag === "invoice_date" || (h.name && h.name.toLowerCase().trim() === "invoice date")) ||
                                    (currentCardForModal?.assign_simplifiedinvoiceheader_field || []).find((h) => h.tag === "invoice_date" || (h.name && h.name.toLowerCase().trim() === "invoice date")) ||
                                    (localInvoiceHeaders || []).find((h) => h.tag === "invoice_date" || (h.header && h.header.toLowerCase().trim() === "invoice date"))
                                );
                                const isInvDateMandatory = Boolean(invDateHdr?.is_mandatory);
                                const invDateAns = Array.isArray(invDateHdr?.invoice_header_answer) ? invDateHdr.invoice_header_answer[0] : null;
                                const isInvDateEdited = Boolean(isFieldEdited(invDateAns) || isFieldEdited(invDateHdr));

                                return (
                                    <>
                                        <div style={{ marginBottom: "18px" }}>
                                            <label style={{ display: "block", fontSize: "13px", fontWeight: 600, color: "#334155", marginBottom: "6px" }}>
                                                {invNoHdr?.name || "Invoice Number"} {isInvNoMandatory && <span style={{ color: "#ef4444" }}>*</span>}
                                            </label>
                                            <input
                                                type="text"
                                                value={invoiceNo || ""}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                placeholder="Enter Invoice Number"
                                                title={isInvNoEdited ? "Edited (MT/QC)" : undefined}
                                                style={{
                                                    width: "100%",
                                                    padding: "10px 14px",
                                                    fontSize: "14px",
                                                    borderRadius: "8px",
                                                    border: error ? "1.5px solid #ef4444" : isInvNoEdited ? "1.5px solid #f97316" : "1px solid #cbd5e1",
                                                    background: !error && isInvNoEdited ? "#fff7ed" : "#ffffff",
                                                    outline: "none",
                                                    boxSizing: "border-box",
                                                    color: "#1e293b",
                                                    transition: "all 0.2s ease",
                                                    fontFamily: "Barlow, sans-serif"
                                                }}
                                            />
                                            {error && (
                                                <span style={{ color: "#ef4444", fontSize: "11px", marginTop: "4px", display: "block" }}>
                                                    Invoice Number is required
                                                </span>
                                            )}
                                        </div>

                                        <div style={{ marginBottom: "10px" }}>
                                            <label style={{ display: "block", fontSize: "13px", fontWeight: 600, color: "#334155", marginBottom: "6px" }}>
                                                {invDateHdr?.name || "Invoice Date"} {isInvDateMandatory && <span style={{ color: "#ef4444" }}>*</span>}
                                            </label>
                                            <input
                                                type="date"
                                                value={invoiceDate || ""}
                                                max={today}
                                                onChange={handleDateChange}
                                                onBlur={handleDateBlur}
                                                title={isInvDateEdited ? "Edited (MT/QC)" : undefined}
                                                style={{
                                                    width: "100%",
                                                    padding: "10px 14px",
                                                    fontSize: "14px",
                                                    borderRadius: "8px",
                                                    border: dateError ? "1.5px solid #ef4444" : isInvDateEdited ? "1.5px solid #f97316" : "1px solid #cbd5e1",
                                                    background: !dateError && isInvDateEdited ? "#fff7ed" : "#ffffff",
                                                    outline: "none",
                                                    boxSizing: "border-box",
                                                    color: "#1e293b",
                                                    transition: "all 0.2s ease",
                                                    fontFamily: "Barlow, sans-serif"
                                                }}
                                            />
                                            {dateError && (
                                                <span style={{ color: "#ef4444", fontSize: "11px", marginTop: "4px", display: "block" }}>
                                                    Invoice Date is required
                                                </span>
                                            )}
                                        </div>
                                    </>
                                );
                            })()}
                        </div>

                        {/* Custom Modal Actions Footer */}
                        {hasPendingRequests ? (
                            <p style={{ color: "#ef4444", fontWeight: "bold", padding: "0 24px 20px 24px", margin: 0, fontSize: "13px" }}>
                                Please complete all pending retailer edits before proceeding.
                            </p>
                        ) : (
                            <div style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                gap: "10px",
                                padding: "16px 24px",
                                borderTop: "1px solid #f1f5f9",
                                background: "#fafafa"
                            }}>
                                <button
                                    onClick={handleClose}
                                    style={{
                                        padding: "9px 20px",
                                        fontSize: "13px",
                                        fontWeight: 600,
                                        borderRadius: "8px",
                                        border: "1px solid #cbd5e1",
                                        background: "#ffffff",
                                        color: "#475569",
                                        cursor: "pointer",
                                        transition: "all 0.15s ease",
                                        fontFamily: "Barlow, sans-serif"
                                    }}
                                >
                                    Close
                                </button>
                                {(() => {
                                    const currentCardForModal = cardDataForSKus?.results?.[selectedCard];
                                    const invNoHdr = (
                                        (currentCardForModal?.invoice_headers || []).find((h) => h.tag === "invoice_number" || (h.name && h.name.toLowerCase().trim() === "invoice number")) ||
                                        (currentCardForModal?.assign_simplifiedinvoiceheader_field || []).find((h) => h.tag === "invoice_number" || (h.name && h.name.toLowerCase().trim() === "invoice number")) ||
                                        (localInvoiceHeaders || []).find((h) => h.tag === "invoice_number" || (h.header && h.header.toLowerCase().trim() === "invoice number"))
                                    );
                                    const isInvNoMandatory = invNoHdr?.is_mandatory !== undefined ? Boolean(invNoHdr.is_mandatory) : true;

                                    const invDateHdr = (
                                        (currentCardForModal?.invoice_headers || []).find((h) => h.tag === "invoice_date" || (h.name && h.name.toLowerCase().trim() === "invoice date")) ||
                                        (currentCardForModal?.assign_simplifiedinvoiceheader_field || []).find((h) => h.tag === "invoice_date" || (h.name && h.name.toLowerCase().trim() === "invoice date")) ||
                                        (localInvoiceHeaders || []).find((h) => h.tag === "invoice_date" || (h.header && h.header.toLowerCase().trim() === "invoice date"))
                                    );
                                    const isInvDateMandatory = Boolean(invDateHdr?.is_mandatory);

                                    const isSaveModalDisabled = (isInvNoMandatory && (!invoiceNo || String(invoiceNo).trim() === "" || error)) ||
                                        (isInvDateMandatory && (!invoiceDate || String(invoiceDate).trim() === "" || dateError));

                                    return (
                                        <button
                                            onClick={handleSave}
                                            disabled={isSaveModalDisabled}
                                            style={{
                                                padding: "9px 24px",
                                                fontSize: "13px",
                                                fontWeight: 600,
                                                borderRadius: "8px",
                                                border: "none",
                                                background: isSaveModalDisabled ? "#cbd5e1" : "#2563eb",
                                                color: "#ffffff",
                                                cursor: isSaveModalDisabled ? "not-allowed" : "pointer",
                                                boxShadow: isSaveModalDisabled ? "none" : "0 2px 4px rgba(37, 99, 235, 0.25)",
                                                transition: "all 0.15s ease",
                                                fontFamily: "Barlow, sans-serif"
                                            }}
                                        >
                                            Save Changes
                                        </button>
                                    );
                                })()}
                            </div>
                        )}
                    </Dialog>

                    {/* Main Content Area */}
                    {selectedCard !== null && selectedCard !== "new-sku" && (
                        <div>
                            {/* Invoice Details Card */}
                            <div className="id-card">
                                <div className="id-card-header" onClick={toggleExpandCollapse}>
                                    <h3 className="id-card-title">Invoice Details</h3>
                                    <div className="id-card-toggle-icon">
                                        {isExpanded ? (
                                            <ExpandLessIcon style={{ fontSize: "22px" }} />
                                        ) : (
                                            <ExpandMoreIcon style={{ fontSize: "22px" }} />
                                        )}
                                    </div>
                                </div>

                                {isExpanded && (
                                    <div>
                                        {localInvoiceHeaders && localInvoiceHeaders.length > 0 ? (
                                            <div className="id-form-grid">
                                                {localInvoiceHeaders
                                                    .filter((item) => !isInvoiceNoOrDate(item))
                                                    .map((detail, index) => {
                                                        const { show_logic_config } = detail;
                                                        let shouldShowField = true;

                                                        if (
                                                            show_logic_config?.show_logic_invoice_header !== null &&
                                                            show_logic_config?.show_logic_invoice_condition &&
                                                            show_logic_config?.show_logic_invoice_option
                                                        ) {
                                                            const dependentHeader = localInvoiceHeaders.find(
                                                                (d) => d.id === show_logic_config.show_logic_invoice_header
                                                            );
                                                            const dependentValue = dependentHeader?.singleInput || "";

                                                            if (show_logic_config.show_logic_invoice_condition === "is_equal_to") {
                                                                shouldShowField = dependentValue === show_logic_config.show_logic_invoice_option;
                                                            } else if (show_logic_config.show_logic_invoice_condition === "is_not_equal_to") {
                                                                shouldShowField = dependentValue !== show_logic_config.show_logic_invoice_option;
                                                            }
                                                        }

                                                        if (!shouldShowField) return null;

                                                        const normType = normalizeHeaderType(detail.invoiceHeadersTypes);
                                                        const isGst = normType === "gstin";
                                                        const isPan = normType === "pan_number";
                                                        const isDropdown = normType === "dropdown";
                                                        const isPhone = normType === "phone_number";
                                                        const isDate = normType === "date";
                                                        const isTime = normType === "time";
                                                        const isInteger = normType === "integer";
                                                        const isDecimal = normType === "decimal";
                                                        const hasError = errorIndexes.includes(index);
                                                        const isFieldEditedFlag = isFieldEdited(detail);

                                                        if (isDropdown) {
                                                            return (
                                                                <div key={index} className="id-form-group">
                                                                    <label className="id-field-label">
                                                                        {detail.header}
                                                                        {detail.is_mandatory && <span className="required-star">*</span>}
                                                                    </label>
                                                                    <select
                                                                        className={`id-field-select ${hasError ? "has-error" : ""} ${isFieldEditedFlag ? "is-edited-orange" : ""}`}
                                                                        title={isFieldEditedFlag ? "Edited (MT/QC)" : undefined}
                                                                        value={detail.singleInput || ""}
                                                                        disabled={!enableEditAnswers}
                                                                        onChange={(e) => {
                                                                            const val = e.target.value === "" ? null : e.target.value;
                                                                            handleSingleInputChange({
                                                                                target: { value: val, type: "select-one" }
                                                                            }, detail.id);
                                                                        }}
                                                                    >
                                                                        <option value="">Select</option>
                                                                        {detail.invoiceHeaderValidation?.choices?.split(";").map((c, idx) => (
                                                                            <option key={idx} value={c.trim()}>{c.trim()}</option>
                                                                        ))}
                                                                    </select>
                                                                    {hasError && (
                                                                        <span className="id-field-error-msg">
                                                                            {errorMessages[index] || `Please select ${detail.header}`}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            );
                                                        }

                                                        return (
                                                            <div key={index} className="id-form-group">
                                                                <label className="id-field-label">
                                                                    {detail.header}
                                                                    {detail.is_mandatory && <span className="required-star">*</span>}
                                                                </label>
                                                                {isPhone ? (
                                                                    <div
                                                                        className={`id-phone-input-wrapper ${hasError ? "has-error" : ""} ${isFieldEditedFlag ? "is-edited-orange" : ""}`}
                                                                        title={isFieldEditedFlag ? "Edited (MT/QC)" : undefined}
                                                                    >
                                                                        <span className="id-phone-prefix">+91</span>
                                                                        <input
                                                                            type="tel"
                                                                            inputMode="numeric"
                                                                            maxLength={10}
                                                                            disabled={!enableEditAnswers}
                                                                            onWheel={(e) => e.target.blur()}
                                                                            onKeyDown={(e) => {
                                                                                if (e.key === "Enter") {
                                                                                    e.preventDefault();
                                                                                    const inputs = Array.from(
                                                                                        document.querySelectorAll('.id-form-grid input:not([type="hidden"]):not([disabled]), .id-form-grid select:not([disabled])')
                                                                                    );
                                                                                    const idx = inputs.indexOf(e.target);
                                                                                    if (idx > -1 && idx < inputs.length - 1) {
                                                                                        inputs[idx + 1].focus();
                                                                                        if (inputs[idx + 1].select) {
                                                                                            inputs[idx + 1].select();
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }}
                                                                            className="id-phone-field-input"
                                                                            placeholder="9876543210"
                                                                            value={(() => {
                                                                                let raw = String(detail.singleInput || "").trim();
                                                                                if (raw.startsWith("+91")) raw = raw.slice(3);
                                                                                else if (raw.startsWith("91") && raw.length > 10) raw = raw.slice(2);
                                                                                return raw;
                                                                            })()}
                                                                            onChange={(e) => handleSingleInputChange(e, detail.id)}
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    <input
                                                                        type={isDate ? "date" : isTime ? "time" : "text"}
                                                                        inputMode={isInteger ? "numeric" : isDecimal ? "decimal" : undefined}
                                                                        step={isInteger ? "1" : isDecimal ? "any" : undefined}
                                                                        maxLength={isGst ? 15 : isPan ? 10 : undefined}
                                                                        disabled={!enableEditAnswers}
                                                                        onWheel={(e) => e.target.blur()}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === "Enter") {
                                                                                e.preventDefault();
                                                                                const inputs = Array.from(
                                                                                    document.querySelectorAll('.id-form-grid input:not([type="hidden"]):not([disabled]), .id-form-grid select:not([disabled])')
                                                                                );
                                                                                const idx = inputs.indexOf(e.target);
                                                                                if (idx > -1 && idx < inputs.length - 1) {
                                                                                    inputs[idx + 1].focus();
                                                                                    if (inputs[idx + 1].select) {
                                                                                        inputs[idx + 1].select();
                                                                                    }
                                                                                }
                                                                            }
                                                                        }}
                                                                        className={`id-field-input ${hasError ? "has-error" : ""} ${isFieldEditedFlag ? "is-edited-orange" : ""}`}
                                                                        title={isFieldEditedFlag ? "Edited (MT/QC)" : undefined}
                                                                        placeholder={isGst ? "e.g. 22AAAAA0000A1Z5" : `Enter ${detail.header}`}
                                                                        value={detail.singleInput || ""}
                                                                        onChange={(e) => handleSingleInputChange(e, detail.id)}
                                                                    />
                                                                )}
                                                                {hasError && (
                                                                    <span className="id-field-error-msg">
                                                                        {errorMessages[index] || `Please enter ${detail.header}`}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        );
                                                    })}

                                                <div className="id-details-actions-row">
                                                    {enableEditAnswers ? (
                                                        hasPendingRequests ? (
                                                            <p style={{ color: "#ef4444", fontWeight: "bold" }}>
                                                                Please complete all pending retailer edits before proceeding.
                                                            </p>
                                                        ) : (
                                                            <button
                                                                className="id-save-details-btn"
                                                                title={`Save Invoice Details (${getShortcutLabel("SAVE_INVOICE_DETAILS")})`}
                                                                onClick={() => handleSaveInvoiceHeader()}
                                                            >
                                                                Save Invoice Details
                                                            </button>
                                                        )
                                                    ) : null}
                                                </div>
                                            </div>
                                        ) : (
                                            <p style={{ textAlign: "center", color: "#94a3b8" }}>No invoice details found.</p>
                                        )}
                                    </div>
                                )}
                            </div>

                            {/* Total Images Action Button */}
                            <button
                                className="id-total-images-btn"
                                title={`View Images / pdf (${getShortcutLabel("VIEW_IMAGES")})`}
                                onClick={handleViewImages}
                            >
                                <ImageIcon style={{ fontSize: "18px" }} />
                                <span>View Images / pdf</span>
                            </button>

                            {/* SKU Line Items Table Card */}
                            {isFullscreen
                                ? createPortal(renderTable, document.body)
                                : renderTable}

                            {/* Bottom Screen Footer Actions */}
                            <div className="id-screen-footer">
                                <div className="id-footer-btns-group">
                                    {enableEditAnswers ? (
                                        hasPendingRequests ? (
                                            <p style={{ color: "#ef4444", fontWeight: "bold" }}>
                                                Please complete all pending retailer edits before proceeding.
                                            </p>
                                        ) : (
                                            <React.Fragment>

                                                <button
                                                    title={`Submit (${getShortcutLabel("SAVE")})`}
                                                    className="id-btn-submit-empanelment"
                                                    onClick={handleSaveNext}
                                                    disabled={hasNewSku || loading || editLoader}
                                                >
                                                    {editLoader ? "Please Wait.." : "Submit"}
                                                </button>
                                            </React.Fragment>
                                        )
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    )}

                    {/* {selectedCard === "new-sku" && (
                        <div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    marginBottom: "20px",
                                }}
                            >
                                <Button
                                    size="medium"
                                    bgColor={black100}
                                    onClick={handleExportToExcelButtonClick}
                                    style={{ marginRight: "10px" }}
                                    isDisabled={selectedSkuIds.length > 1000 || selectedSkuIds.length === 0}
                                    title={selectedSkuIds.length > 1000 ? "Cannot export more than 1000 entries" : null}
                                >
                                    <span
                                        style={{
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            color: "#3E96C8",
                                        }}
                                    >
                                        <ExcelIcon />
                                        Export to CSV
                                    </span>
                                </Button>
                            </div>

                            <table className="custom-table">
                                <thead>
                                    <tr>
                                        <th>Select</th>
                                        <th>New SKU's</th>
                                        <th>Manufacturer</th>
                                        <th>Brand</th>
                                        <th>Variant</th>
                                        <th>Sub Category</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {newAddedSKuTest.map((row, rowIndex) =>
                                        row.simplifiedinvoiceaddonsku.map((sku, skuIndex) => (
                                            <tr key={`${rowIndex}-${skuIndex}`}>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) =>
                                                            handleCheckboxChange(sku.id, e.target.checked)
                                                        }
                                                    />
                                                </td>
                                                <td>{sku.add_on_sku || "N/A"}</td>
                                                <td>{sku.manufacturer || "N/A"}</td>
                                                <td>{sku.brand || "N/A"}</td>
                                                <td>{sku.variant || "N/A"}</td>
                                                <td>{sku.sub_category || "N/A"}</td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )} */}
                </div>
            )}

            {isFirstModalActive && (
                <Modal
                    withHeader={false}
                    displayFlex={true}
                    top="6%"
                    modalWidth="600px"
                    closeIconColor={black300}
                    closeAction={() => {
                        setModalErrorMessage("");
                        setFirstModalActive(false);
                        setModalSearchText("");
                    }}
                >
                    <div style={{ padding: "26px 28px", fontFamily: "inherit" }}>
                        {/* Modal Header */}
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "18px" }}>
                            <div>
                                <h3 style={{ margin: 0, fontSize: "20px", fontWeight: 700, color: "#1e293b", letterSpacing: "-0.3px" }}>
                                    Select Master Catalog SKU
                                </h3>
                            </div>
                            <button
                                onClick={() => {
                                    setModalErrorMessage("");
                                    setFirstModalActive(false);
                                    setModalSearchText("");
                                }}
                                style={{
                                    background: "#f1f5f9",
                                    border: "none",
                                    borderRadius: "50%",
                                    width: "36px",
                                    height: "36px",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#64748b",
                                    transition: "all 0.15s ease"
                                }}
                            >
                                <CloseIcon style={{ fontSize: "18px" }} />
                            </button>
                        </div>

                        {/* In-Modal Error Banner */}
                        {modalErrorMessage && (
                            <div style={{
                                background: "#fef2f2",
                                border: "1px solid #fca5a5",
                                color: "#ef4444",
                                padding: "10px 14px",
                                borderRadius: "8px",
                                fontSize: "13px",
                                fontWeight: 600,
                                marginBottom: "14px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between"
                            }}>
                                <span>{modalErrorMessage}</span>
                                <CloseIcon style={{ cursor: "pointer", fontSize: "16px" }} onClick={() => setModalErrorMessage("")} />
                            </div>
                        )}

                        {/* Search Input */}
                        <div style={{ position: "relative", marginBottom: "16px" }}>
                            <SearchIcon style={{ position: "absolute", left: "16px", top: "50%", transform: "translateY(-50%)", color: "#94a3b8", fontSize: "20px", pointerEvents: "none" }} />
                            <input
                                type="text"
                                placeholder="Search SKU by name or ID..."
                                value={modalSearchText}
                                onChange={(e) => {
                                    setModalSearchText(e.target.value);
                                    setModalErrorMessage("");
                                }}
                                style={{
                                    width: "100%",
                                    padding: "12px 16px 12px 46px",
                                    fontSize: "14px",
                                    borderRadius: "10px",
                                    border: "1.5px solid #cbd5e1",
                                    outline: "none",
                                    boxSizing: "border-box",
                                    color: "#1e293b",
                                    backgroundColor: "#ffffff",
                                    transition: "all 0.2s ease",
                                    fontFamily: "inherit"
                                }}
                                onFocus={(e) => {
                                    e.target.style.borderColor = "#3b82f6";
                                    e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.12)";
                                }}
                                onBlur={(e) => {
                                    e.target.style.borderColor = "#cbd5e1";
                                    e.target.style.boxShadow = "none";
                                }}
                            />
                        </div>

                        {/* SKU List Container */}
                        <div className="sku-picker-list">
                            {loadingSku ? (
                                <div style={{ textAlign: "center", padding: "40px 20px", color: "#64748b" }}>
                                    <CircularProgress size={32} style={{ color: "#2563eb" }} />
                                    <p style={{ margin: "12px 0 0 0", fontSize: "13px", fontWeight: 500 }}>Loading catalog SKUs...</p>
                                </div>
                            ) : filteredModalSkuOptions.length === 0 ? (
                                <div style={{ textAlign: "center", padding: "40px 20px", color: "#94a3b8", fontSize: "14px" }}>
                                    No matching SKUs found.
                                </div>
                            ) : (
                                filteredModalSkuOptions.map((item, idx) => {
                                    const isSelected =
                                        tableData[testRowIndex]?.sku === item.sku ||
                                        tableData[testRowIndex]?.[testCallIndex?.column?.id] === item.sku_name;

                                    return (
                                        <div
                                            key={idx}
                                            className={`sku-picker-item ${isSelected ? "selected" : ""}`}
                                            onClick={() => {
                                                setModalErrorMessage("");

                                                const updatedTableData = [...tableData];
                                                const targetRow = updatedTableData[testRowIndex] || {};
                                                const colId = testCallIndex?.column?.id || "sku_name";

                                                const targetSkuId = item.sku !== undefined && item.sku !== null ? String(item.sku).trim() : "";
                                                const targetSkuName = (item.sku_name || item.name || "").toString().trim().toLowerCase();
                                                const targetAddonName = (item.add_on_sku || "").toString().trim().toLowerCase();

                                                const existingRowsWithSku = tableData.filter((r, idx) => {
                                                    if (idx === testRowIndex) return false;
                                                    const rSkuId = (r.sku !== undefined && r.sku !== null && r.sku !== "")
                                                        ? String(r.sku).trim()
                                                        : ((r.sku_id !== undefined && r.sku_id !== null && r.sku_id !== "") ? String(r.sku_id).trim() : "");
                                                    const rSkuName = (r.sku_name || r[testCallIndex?.column?.id] || "").toString().trim().toLowerCase();
                                                    const rAddonName = (r.add_on_sku || "").toString().trim().toLowerCase();

                                                    const idMatches = Boolean(targetSkuId && rSkuId && targetSkuId === rSkuId);
                                                    const nameMatches = Boolean(targetSkuName && (rSkuName === targetSkuName || rAddonName === targetSkuName));
                                                    const addonMatches = Boolean(targetAddonName && (rAddonName === targetAddonName || rSkuName === targetAddonName));

                                                    return idMatches || nameMatches || addonMatches;
                                                });

                                                let calculatedRowIndex = 1;
                                                if (existingRowsWithSku.length === 0) {
                                                    calculatedRowIndex = 1;
                                                } else if (existingRowsWithSku.length > 0) {
                                                    const largestRowIndex = Math.max(...existingRowsWithSku.map((r) => Number(r.row_index) || 1));
                                                    calculatedRowIndex = largestRowIndex + 1;
                                                }

                                                const updatedRow = {
                                                    ...targetRow,
                                                    [colId]: item.sku_name,
                                                    sku_name: item.sku_name,
                                                    sku: item.sku,
                                                    sku_id: item.sku,
                                                    row_index: calculatedRowIndex,
                                                };
                                                columns.forEach((c) => {
                                                    if (isAutoPopulatedDisabledSkuField(c)) {
                                                        const currentVal = updatedRow[c.accessor];
                                                        if (typeof currentVal === "object" && currentVal !== null) {
                                                            updatedRow[c.accessor] = {
                                                                ...currentVal,
                                                                value: item.sku_name,
                                                            };
                                                        } else {
                                                            updatedRow[c.accessor] = item.sku_name;
                                                        }
                                                    }
                                                });
                                                updatedTableData[testRowIndex] = updatedRow;
                                                setTableData(updatedTableData);
                                                setValidationErrors((prevErrors) =>
                                                    prevErrors.filter(
                                                        (err) => !(err.rowIndex === testRowIndex && err.columnId === "sku_name")
                                                    )
                                                );
                                                setFirstModalActive(false);
                                                setModalSearchText("");
                                            }}
                                        >
                                            <span className="sku-picker-item-name">{item.sku_name}</span>
                                            {item.sku && (
                                                <span className="sku-picker-id-badge">#{item.sku}</span>
                                            )}
                                        </div>
                                    );
                                })
                            )}
                        </div>

                        {/* Modal Pagination Bar */}
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "18px", paddingTop: "16px", borderTop: "1px solid #e2e8f0" }}>
                            <div style={{ fontSize: "13px", color: "#64748b", fontWeight: 500 }}>
                                Page <strong>{skuPage}</strong> of <strong>{skuTotalPages}</strong> ({skuTotalCount ? skuTotalCount.toLocaleString() : 0} SKUs)
                            </div>

                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <button
                                    onClick={() => setSkuPage((prev) => Math.max(1, prev - 1))}
                                    disabled={skuPage <= 1 || loadingSku}
                                    style={{
                                        padding: "7px 18px",
                                        fontSize: "13px",
                                        fontWeight: 600,
                                        borderRadius: "8px",
                                        border: "1.5px solid #cbd5e1",
                                        background: skuPage <= 1 ? "#f8fafc" : "#ffffff",
                                        color: skuPage <= 1 ? "#94a3b8" : "#1e293b",
                                        cursor: skuPage <= 1 ? "not-allowed" : "pointer",
                                        transition: "all 0.15s ease",
                                        display: "inline-flex",
                                        alignItems: "center"
                                    }}
                                >
                                    ‹ Prev
                                </button>

                                <span style={{ fontSize: "13px", fontWeight: 700, color: "#334155", margin: "0 4px" }}>
                                    {skuPage} / {skuTotalPages}
                                </span>

                                <button
                                    onClick={() => setSkuPage((prev) => Math.min(skuTotalPages, prev + 1))}
                                    disabled={skuPage >= skuTotalPages || loadingSku}
                                    style={{
                                        padding: "7px 18px",
                                        fontSize: "13px",
                                        fontWeight: 600,
                                        borderRadius: "8px",
                                        border: "1.5px solid #cbd5e1",
                                        background: skuPage >= skuTotalPages ? "#f8fafc" : "#ffffff",
                                        color: skuPage >= skuTotalPages ? "#94a3b8" : "#1e293b",
                                        cursor: skuPage >= skuTotalPages ? "not-allowed" : "pointer",
                                        transition: "all 0.15s ease",
                                        display: "inline-flex",
                                        alignItems: "center"
                                    }}
                                >
                                    Next ›
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
            )}



            {cropImageModalUrl && (
                <Modal
                    withHeader
                    top="10%"
                    modalWidth="520px"
                    closeIconColor={black300}
                    closeAction={() => {
                        setCropImageModalUrl(null);
                    }}
                >
                    <div style={{ padding: "20px", textAlign: "center" }}>
                        <h4 style={{ margin: "0 0 16px 0", fontFamily: "barlow", fontSize: "16px", color: "#1e293b" }}>
                            OCR Crop Image Source
                        </h4>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", background: "#f8fafc", padding: "12px", borderRadius: "8px", border: "1px solid #e2e8f0" }}>
                            <img
                                src={cropImageModalUrl}
                                alt="OCR Source Crop"
                                style={{ maxWidth: "100%", maxHeight: "350px", objectFit: "contain", borderRadius: "4px" }}
                            />
                        </div>
                        <div style={{ marginTop: "20px", display: "flex", justifyContent: "center" }}>
                            <Button
                                onClick={() => {
                                    setCropImageModalUrl(null);
                                }}
                                size="medium"
                                bgColor="#318CE7"
                                color="#FFF"
                            >
                                Close
                            </Button>
                        </div>
                    </div>
                </Modal>
            )}

            <Snackbar
                open={toastOpen}
                autoHideDuration={3000}
                onClose={() => setToastOpen(false)}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                style={{ zIndex: 999999 }}
            >
                <div
                    style={{
                        background: "#ef4444",
                        color: "#ffffff",
                        padding: "10px 20px",
                        borderRadius: "8px",
                        fontSize: "14px",
                        fontWeight: 600,
                        fontFamily: "Barlow, sans-serif",
                        boxShadow: "0 10px 15px -3px rgba(239, 68, 68, 0.3)",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px"
                    }}
                >
                    <span>{toastMessage}</span>
                </div>
            </Snackbar>
        </React.Fragment>
    );
};

const mapStateToProps = ({ user }) => {
    const { considered_workflow_permission } = user?.user_details || {};
    return {
        workflow_permission: considered_workflow_permission,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        notificationHandler: bindActionCreators(triggerNotification, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceDigitization);